// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:00:58.740Z
// Property: Piper Lofts (ID: 6767906449167655)
// Collections: 30 amenities, 8 floorplans (live), 18 photos, 79 POIs, 5 reviews, 3 virtual tours, 10 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167655",
  "property_external_id": "1830485",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/piper-lofts-kansas-city-mo/47jcrph/",
  "property_google_business_url": "https://www.google.com/maps/place/Piper+Lofts+at+Crossroads+Apartments/@39.0890626,-94.5857146,888m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0f0410b42fc59:0x9b6a963db948b2f1!8m2!3d39.0890626!4d-94.5857146!16s%2Fg%2F11b6d7rg_8?entry=ttu&g_ep=EgoyMDI2MDgxMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "39355900278",
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "pID: 1830485\npCode: p1798339",
  "property_status": null,
  "property_slug": "piper-lofts",
  "property_name": "Piper Lofts",
  "property_website_url": "https://www.piperlofts.com/",
  "property_domain": "https://www.piperlofts.com/",
  "property_address": "117 W 20th St",
  "property_full_address": "117 W 20th St, Kansas City, MO 64108",
  "property_address_1": "117 W 20th St",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64108",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Crossroads",
  "property_address_latitude": "39.088907",
  "property_address_longitude": "-94.58573779999999",
  "property_email": "rentcafe.pl@pricekc.com",
  "property_phone": "(816) 323-5787",
  "property_call_tracking_phone": "816-323-5787",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Historic loft character in the Crossroads.</strong> Explore open one-, two-, and three-bedroom layouts inside the landmark H.D. Lee Building, where exposed brick, concrete floors, soaring ceilings, downtown views, and polished modern finishes set the tone for easy downtown living.</p>",
  "property_long_description": "Welcome home to Piper Lofts at Crossroads Apartments, the premier apartments for rent in the Crossroads Art District of Kansas City! Our loft-style community in the 100-year-old HD Lee building offers stunning one, two, and three bedroom apartments. Every floor plan features concrete floors, exposed brick walls, twelve-foot ceilings, fully-equipped kitchens with stainless steel appliances and granite countertops, smart lock doors, and a washer and dryer in-unit, creating the ideal space for both relaxing and entertaining!Enjoy our exceptional amenities, which include a rooftop swimming pool, sundeck, and picnic area with BBQ grills. Our welcoming clubhouse features a fitness center, 24-hour micro market, and coffee/tea bar. For your convenience, we also offer off-street parking and on-site management and maintenance teams. Select a floor plan to take a walk through video tour, or call our friendly leasing staff today to schedule a personal tour of your new home at Piper Lofts at Crossroads Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a0596c-f072-77e1-8a43-161747305892.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of Piper Lofts apartment building at sunset with a clock tower.",
    "public_id": "01a0596c-f072-77e1-8a43-161747305892",
    "storage_key": "property/6767906449167655/01a0596c-f072-77e1-8a43-161747305892.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "118",
  "property_year_built": "2008",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": "200",
  "property_application_fee": "60",
  "property_fees_deposit_info": "Deposit: $250-450",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of 2 pets allowed in the apartment home.",
  "property_pet_policy_description": "Our community is happy to accept dogs and cats. Maximum of 2 pets allowed in the apartment home. Monthly rent $25.00 per pet. $300 non‑refundable fee for 1 pet; $500 non‑refundable fee for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://piperlofts.securecafeapplicant.com/onlineleasing/content3/access/piper-lofts-llc/floorplans",
  "property_resident_portal_url": "https://piperlofts.securecafe.com/residentservices/piper-lofts-llc/userlogin.aspx",
  "property_apply_now_url": "https://piperlofts.securecafeapplicant.com/onlineleasing/content3/access/piper-lofts-llc/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-b61a-77f9-b70c-1c3c39c68907.webp",
  "property_primary_logo_media": {
    "alt_text": "Piper Lofts at Crossroads logo",
    "public_id": "019ff68e-b61a-77f9-b70c-1c3c39c68907",
    "storage_key": "property/6767906449167655/019ff68e-b61a-77f9-b70c-1c3c39c68907.webp",
    "width": 3072,
    "height": 838
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a0b05d-f343-761d-a1b0-58802ee5e2c0.webp",
  "property_fav_icon_media": {
    "alt_text": "Piper Lofts at Crossroads logo",
    "public_id": "01a0b05d-f343-761d-a1b0-58802ee5e2c0",
    "storage_key": "property/6767906449167655/01a0b05d-f343-761d-a1b0-58802ee5e2c0.webp",
    "width": 256,
    "height": 256
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff7b5-fe03-72ab-9140-0b1ece21f716.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019ff7b5-fe03-72ab-9140-0b1ece21f716",
    "storage_key": "property/6767906449167655/019ff7b5-fe03-72ab-9140-0b1ece21f716.webp",
    "width": 1280,
    "height": 349
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff7b5-f2b4-75fa-a5d7-f871fa341dd6.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019ff7b5-f2b4-75fa-a5d7-f871fa341dd6",
    "storage_key": "property/6767906449167655/019ff7b5-f2b4-75fa-a5d7-f871fa341dd6.webp",
    "width": 1280,
    "height": 349
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#666666",
  "property_secondary_color": "#003e75",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1210 - 1375",
  "property_sqft_min": "1210",
  "property_sqft_max": "1375",
  "property_price_range": "2726 - 9194",
  "property_price_min": "2726",
  "property_price_max": "9194",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/PiperLofts",
  "property_instagram_url": "https://www.instagram.com/piperloftskc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWfxCC0HwwIcR8bJIuT2Waps",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": "https://www.tiktok.com/@pbapartmentskc",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Piper Lofts",
  "property_home_romance_title": "Embrace Life and Love in Your Dream Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Loft amenities with a downtown point of view.</strong> Piper Lofts pairs historic Crossroads character with everyday ease—think a rooftop pool, sundeck, grilling area, and lounge spaces framed by city views. Inside, exposed brick, concrete floors, oversized windows, vaulted ceilings, stainless steel appliances, granite countertops, and in-home laundry keep the loft feel polished and practical, with a 24-hour fitness center, micro market, package lockers, dog park, and pet spa rounding out the experience.</p>",
  "property_home_floorplans_blurb": "<p><strong>Loft layouts with room to make a statement.</strong> Choose from one-, two-, and three-bedroom floor plans in the Crossroads, each pairing open-concept design with standout loft character—concrete floors, exposed brick, oversized windows, and vaulted ceilings. Granite countertops, stainless steel appliances, in-home laundry, walk-in closets, and select outdoor spaces add everyday ease.</p>",
  "property_home_gallery_blurb": "<p><strong>See Piper Lofts in focus.</strong> Preview the Crossroads character that sets this Kansas City address apart: exposed brick, polished concrete floors, tall ceilings, granite countertops, and stainless steel kitchens. Then look up to rooftop views with a pool, sundeck, grills, and skyline backdrop—plus lounge and fitness spaces that bring the building’s vintage texture into every frame.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Crossroads energy, right outside.</strong> Step from Piper Lofts into brick-lined streets, murals, and KC favorites like Mildred’s, Farina, Extra Virgin, Town Topic, and Tom’s Town. First Friday art walks, Green Lady Lounge, Freight House dining, and Union Station are all close by, while the 19th &amp; Main KC Streetcar stop keeps more of the city easy to reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews say it best.</strong><br>At Piper Lofts, praise centers on friendly, responsive service, with April and Tiffany often recognized for going above and beyond. Reviews also call out a welcoming community feel, spacious lofts with big windows and city views, pet-friendly touches, and standout amenities like the rooftop pool and renovated gym. Read more to see why “they really care” comes through again and again.</p>",
  "property_neighborhood_blurb": "<p>Nestled in downtown Kansas City’s Crossroads Arts District, Piper Lofts Kansas City immerses you in an active, walkable downtown KC neighborhood alive with creative energy and culture. This lively district seamlessly blends its historic charm with a vibrant urban lifestyle: colorful murals, art galleries, and indie boutiques are just steps from trendy restaurants and buzzing cafes. By day, the sidewalks bustle with creative spirit and friendly faces; by night, the streets glow with a warm, romantic energy as jazz melodies and the aroma of gourmet dining fill the air. Every moment at Piper Lofts feels both authentic and aspirational—a chance to savor the cultural appeal, convenience, and charm of urban living and fall in love with Kansas City all over again.&nbsp;</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities with real loft character.</strong> At Piper Lofts, daily convenience is built into the building—not tacked on. Start with a rooftop pool, sundeck, grilling area, and lounge spaces that make the most of downtown views, then add practical perks like controlled access, key fob entry, package lockers, valet trash pickup, on-site maintenance, and a 24-hour micro market.</p><p>Inside your loft, historic texture meets polished function: concrete floors, exposed brick, oversized windows, vaulted ceilings, stainless steel appliances, granite countertops, island kitchens in select homes, in-home washer and dryer, and smart details like high-speed internet access and window coverings. Add a 24-hour fitness center, clubhouse, dog park, and pet spa, and you have Crossroads apartment amenities designed to make staying in feel just as appealing as stepping out. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see them up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready for historic loft living in the Crossroads?</strong> Start your application online for Piper Lofts, where exposed brick, concrete floors, soaring ceilings, and downtown views meet open layouts, polished finishes, and everyday conveniences in the landmark H.D. Lee Building.</p>",
  "property_contactus_blurb": "<p>Use our chatbot to see our interactive tour scheduling assistant or send us a tour request using this form.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Piper Lofts?</strong> Start here for quick answers about leasing, <a href=\"/floor-plans\">loft layouts</a>, everyday features, and life in the Crossroads. If you need more detail, the leasing team is happy to help—just <a href=\"/contact-us\">reach out</a> anytime.</p>",
  "property_floorplans_blurb": "<p>Discover your perfect living space at Piper Lofts, where historic charm meets modern convenience in the heart of Kansas City. Our thoughtfully designed floor plans offer a range of options to suit your lifestyle, from cozy studios to spacious multi-bedroom layouts. Each loft features unique architectural details, high ceilings, and contemporary finishes that blend industrial style with urban sophistication. Whether you're seeking a vibrant downtown vibe or a serene retreat, Piper Lofts provides the ideal backdrop for your next chapter. Explore our floor plans today and find your dream loft in this iconic community!</p>",
  "property_gallery_blurb": "<p><strong>Picture the loft life from every angle.</strong> Browse the Piper Lofts photo gallery for a closer look at the textures and spaces that give this Crossroads address its signature feel: exposed brick warmed by natural light, polished concrete floors, tall ceilings, and kitchens finished with granite and stainless steel.</p><p>Move from open living areas to rooftop scenes where the pool, sundeck, grills, and skyline views create a standout backdrop. You’ll also see inviting lounge spaces, fitness areas, and details that make each home feel connected to the building’s vintage character. Like what you see? Compare <a href=\"/floor-plans\">available loft layouts</a>, explore more <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Piper Lofts in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Piper Lofts on the map.</strong> See available loft apartments in the Crossroads, then zoom out to discover the galleries, dining, transit, and downtown energy surrounding this historic Kansas City address.</p>",
  "property_pets_blurb": "<p><strong>Loft living works better when pet care is part of the plan.</strong> At Piper Lofts, dogs and cats are welcome in a Crossroads setting that keeps everyday routines close to home. Step out to the on-site dog park for fresh air, use the pet spa after muddy walks, then come back to open loft layouts, concrete floors, and oversized windows that make daily life feel easy.</p><p>For bigger outings, nearby green space and Penn Valley’s off-leash dog park add more room to roam. Plus, Price Brothers Pet Royalty Club perks connect you with local pet-service partners for added convenience. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the loft life.</strong> If Piper Lofts’ exposed brick, soaring ceilings, downtown views, and easy Crossroads rhythm are part of what makes home feel like home, invite a friend to experience it too. Send a referral and help them find their place in this historic Kansas City landmark.</p>",
  "property_residentaccess_blurb": "<p>With our easy to use Resident Portal, you can pay your rent, review your payment history, and submit maintenance requests online. Anytime. Anywhere. 24/7. It's fast, convenient, and simple.&nbsp;</p><p>Don't forget to download the resident app!</p>",
  "property_reviews_blurb": "<p><strong>See why residents love life at Piper Lofts.</strong><br>Reviews highlight a team that is friendly, responsive, and genuinely invested, with April and Tiffany earning repeated shoutouts for going above and beyond. Residents also praise the welcoming community feel, from wine-and-charcuterie gatherings to everyday chats in the office.</p><p>You’ll also hear about spacious lofts with big windows, city views, pet-friendly touches, and favorite shared spaces like the rooftop pool and renovated gym. As one resident put it, “I can tell they really care”—and that care comes through again and again in the experiences shared here.</p>",
  "property_created_at": "1786547912304",
  "property_scheduletour_blurb": "<p><strong><u>Use our chatbot to see our interactive tour scheduling assistant</u></strong> or send us a tour request using this form.</p><p><strong>Open Saturdays by Appointment Only</strong></p><p><em>Please contact us directly to schedule for Saturday.</em></p><p>Experience Piper Lofts with a personalized, one-on-one walk-through led by our knowledgeable onsite team members. Our Guided Tours give you the chance to explore amenities, tour model homes, ask questions in real time, and get a true feel for the lifestyle Piper Lofts offers. It's the most interactive, relationship-driven way to experience living at Piper Lofts.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong> The Piper Lofts leasing team will follow up soon. In the meantime, picture historic loft character in the Crossroads, with exposed brick, soaring ceilings, downtown views, and polished modern finishes all coming together in one landmark address.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the loft before you visit.</strong> Use the virtual tours to move through Piper Lofts at your own pace, starting with the A2 one-bedroom and the B1 and B2 two-bedroom layouts. Look closely at the details that define these Crossroads apartments: open loft flow, exposed brick, concrete floors, tall ceilings, stainless steel appliances, granite countertops, in-home laundry, and oversized windows that help each space feel bright and connected.</p><p>As you explore, pause where it matters—kitchen sightlines, living-area proportions, bedroom placement, storage, and the overall feel of each layout. When a tour stands out, compare it with current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Piper Lofts in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Piper Lofts",
  "property_seo_title_home": "Kansas City Loft Apartments | Piper Lofts at Crossroads",
  "property_seo_description_home": "Discover Kansas City loft apartments at Piper Lofts in the Crossroads Arts District, featuring historic character, modern features, and downtown access.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments in Crossroads KC",
  "property_seo_description_floorplans": "Explore 1, 2, and 3-bedroom apartments in Crossroads KC at Piper Lofts, with loft-style layouts ranging from approximately 737 to 1,921 sq. ft.",
  "property_seo_title_amenities": "Kansas City Loft Amenities",
  "property_seo_description_amenities": "Explore Piper Lofts amenities including a rooftop pool, fitness center, clubhouse, covered parking, and distinctive loft-style apartment features.",
  "property_seo_title_gallery": "Kansas City Loft Apartment Photos",
  "property_seo_description_gallery": "Browse photos of Piper Lofts in Kansas City, including historic loft interiors, rooftop amenities, community spaces, and Crossroads surroundings.",
  "property_seo_title_virtualtours": "Virtual Tours of Kansas City Lofts",
  "property_seo_description_virtualtours": "Take a virtual tour of select Kansas City loft apartments at Piper Lofts and explore available layouts, interior features, and loft-style details online.",
  "property_seo_title_interactivemap": "Interactive Map | Piper Lofts Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Piper Lofts in Kansas City! Explore stylish one, two, and three-bedroom layouts with great amenities.",
  "property_seo_title_neighborhood": "Crossroads Lofts in Kansas City",
  "property_seo_description_neighborhood": "Explore Crossroads loft living at Piper Lofts near galleries, restaurants, the KC Streetcar, Union Station, Crown Center, and downtown Kansas City.",
  "property_seo_title_contact": "Contact Piper Lofts at Crossroads in Kansas City, MO",
  "property_seo_description_contact": "Contact Piper Lofts in Kansas City for information about availability, floor plans, amenities, tours, applications, or our Crossroads location.",
  "property_seo_title_faqs": "FAQs | Apartments in Kansas City, MO",
  "property_seo_description_faqs": "Unlock the secrets of upscale living at Piper Lofts in Kansas City, MO. Check out our FAQs for insights on amenities, floor plans, and community life!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Join the Piper Lofts community in Kansas City! Read resident reviews and find out why our unique amenities and stylish apartments create a perfect home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Elevate your lifestyle at Piper Lofts in Kansas City! Choose from stylish one, two, or three-bedroom apartments with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Piper Lofts at Crossroads Resident Portal | Kansas City",
  "property_seo_description_residentaccess": "Access the Piper Lofts resident portal to make rent payments, review account information, submit maintenance requests, and manage resident services.",
  "property_seo_title_referafriend": "Refer A Friend | Piper Lofts",
  "property_seo_description_referafriend": "Refer a friend to Piper Lofts in Kansas City, MO! Great friends make the best neighbors. Share the lifestyle of luxury living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Piper Lofts",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Piper Lofts in Kansas City, MO. Schedule your tour today and find your perfect urban retreat among stunning amenities!",
  "property_seo_title_privacy": "Privacy Policy | Piper Lofts",
  "property_seo_description_privacy": "Your privacy matters at Piper Lofts! Learn how we protect your information and enjoy peace of mind in the heart of Kansas City, MO. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Piper Lofts",
  "property_seo_description_accessibility": "At Piper Lofts in Kansas City, we prioritize digital inclusion with accessible features for all. Join our vibrant community where everyone belongs!",
  "property_seo_title_sitemap": "Sitemap | Piper Lofts",
  "property_seo_description_sitemap": "Uncover every detail about Piper Lofts in Kansas City, MO. Dive into our sitemap to easily navigate your future home and amenities. Your next adventure awaits!",
  "property_seo_title_thankyou": "Thank You | Piper Lofts",
  "property_seo_description_thankyou": "Thank you for reaching out! Our team at Piper Lofts in Kansas City will connect with you soon. Get ready to find your perfect urban haven!",
  "property_seo_title_pets": "Pet-Friendly Apartments Downtown Kansas City",
  "property_seo_description_pets": "Learn about pet-friendly apartments in downtown Kansas City at Piper Lofts, including current pet fees, policies, dog park, and pet spa information.",
  "property_updated_at": "1793628770158",
  "amenities": [
    {
      "id": "ec_589ce5c80ad485c21afb2b6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930338",
      "title": "Pool with BBQ, Sundeck & Stunning City Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f96d2d167e6c59a42419ba8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930328",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7e3dbf0524e9ab8a3fd9651",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930339",
      "title": "Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fce3f794d31083b7f5b5ba3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930336",
      "title": "On-Call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51761d58a5bcb31c5ef2ead2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930348",
      "title": "Covered Parking Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21076089bc391edf5a7b56b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930332",
      "title": "24-Hour Micro Market",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6f138236563eb6e8fc419c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930346",
      "title": "Coffee & Tea Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09ca4bcebd42147f432b7ae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "124329958",
      "title": "Pet Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21506c583417935974be5bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930330",
      "title": "Luxor Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfe5167615c8a57ce27300ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930341",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51548b53058db0d9d3e3cabf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930334",
      "title": "Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69c978389c79804989ecacef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930333",
      "title": "Controlled-Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c1c67f345662f21c04e5655",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930342",
      "title": "On-Site Patrol Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6f79927f5fa315d030fb8ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930349",
      "title": "Smoke-Free Living",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a96786b92c8536d22b33ef42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930329",
      "title": "Complimentary Wi-Fi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d5ee171a3c7a6f2f9f81460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "122755388",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7adb38ea9556de45912c6eac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930379",
      "title": "Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a7b343a0c486dabaa1cc3be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930355",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6d5eb20d89c787c04c0d473",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930354",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2775b2f9a88b140c37d224b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930352",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a384a76b6edb80a2dde37c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930353",
      "title": "Sink Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a10155d3d9e8774c9e3ba9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930380",
      "title": "Smart Locks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9111e27cdd1ed07321f326c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930385",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ab24717856f861d74630e5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930356",
      "title": "Stove",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b716cc34de51908cb68d7d3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930384",
      "title": "Eat-in-Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6196fa4d258bfe95a871e1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930381",
      "title": "Large Soaking Tub with Jacuzzi Jets",
      "amount": "false",
      "description": "In Select Units",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90182bb41fc3d8262a1121b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "124329969",
      "title": "Exposed Brick Walls*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ab91b03c491a8e316d3ac1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "121930383",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bfd0c8723ab119c0483f86d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "124329966",
      "title": "Polished Concrete Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39ea8fbab5dc99949f2ab2cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "external_id": "124962244",
      "title": "Roller Shades",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_49f7e624a871eb8781c0d4c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-ca05-764c-b17a-fee2d1d97f3c.webp",
      "image_media": {
        "alt_text": "Historic brick apartment building exterior at sunset with city skyline in background.",
        "public_id": "01a01005-ca05-764c-b17a-fee2d1d97f3c",
        "storage_key": "property/6767906449167655/01a01005-ca05-764c-b17a-fee2d1d97f3c.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Experience urban living in this beautifully maintained historic brick apartment building, perfectly situated against a vibrant sunset sky with the city skyline beyond.",
      "link": "false",
      "alt_text": "Historic brick apartment building exterior at sunset with city skyline in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-117 W 20th St-14-.jpg"
    },
    {
      "id": "ec_c18f15536466e0f82c92d922",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-d699-71c1-b2db-48378168ddcb.webp",
      "image_media": {
        "alt_text": "Spacious living and dining area with an open-concept kitchen.",
        "public_id": "01a01005-d699-71c1-b2db-48378168ddcb",
        "storage_key": "property/6767906449167655/01a01005-d699-71c1-b2db-48378168ddcb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience modern urban living in this stunning apartment featuring an open-concept living, dining, and kitchen area with large windows and exposed brick.",
      "link": "false",
      "alt_text": "Spacious living and dining area with an open-concept kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-117 W 20th St-6_final.jpg"
    },
    {
      "id": "ec_5a369d9f9d8d5c29cddf8680",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-d6a4-7789-b6db-d65379693c49.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark gray cabinets, and a black island.",
        "public_id": "01a01005-d6a4-7789-b6db-d65379693c49",
        "storage_key": "property/6767906449167655/01a01005-d6a4-7789-b6db-d65379693c49.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into this sleek, modern kitchen featuring stainless steel appliances, including a refrigerator, oven, microwave, and dishwasher. The dark gray cabinetry and black countertops provide a sophisticated look, complemented by an island perfect for meal prep or casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, dark gray cabinets, and a black island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-117 W 20th St-11.jpg"
    },
    {
      "id": "ec_a7f4ca9fdf89b34dbcddad1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-d5ef-743b-8ee4-04b7fad42deb.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-sized bed, concrete ceiling, and large windows with city views.",
        "public_id": "01a01005-d5ef-743b-8ee4-04b7fad42deb",
        "storage_key": "property/6767906449167655/01a01005-d5ef-743b-8ee4-04b7fad42deb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience urban living in this stylish bedroom featuring a comfortable king-sized bed, industrial-chic concrete ceilings, and breathtaking city skyline views through expansive windows.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-sized bed, concrete ceiling, and large windows with city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-117 W 20th St-7_final.jpg"
    },
    {
      "id": "ec_36f035a69154923b5ffb2281",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-d55f-7005-b554-6b66dcf6338e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with glass shower, toilet, and floating sink.",
        "public_id": "01a01005-d55f-7005-b554-6b66dcf6338e",
        "storage_key": "property/6767906449167655/01a01005-d55f-7005-b554-6b66dcf6338e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A stylish bathroom featuring a glass-enclosed shower with dark tile, a modern toilet, and a sleek floating vanity with a vessel sink.",
      "link": "false",
      "alt_text": "Modern bathroom with glass shower, toilet, and floating sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-117 W 20th St-8.jpg"
    },
    {
      "id": "ec_9ce0c682075c068cb0412ef9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-d69d-71bd-90a6-1b6b3bcaa161.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and an island, overlooking a large window.",
        "public_id": "01a01005-d69d-71bd-90a6-1b6b3bcaa161",
        "storage_key": "property/6767906449167655/01a01005-d69d-71bd-90a6-1b6b3bcaa161.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen featuring stainless steel appliances, a central island, and ample natural light from large industrial-style windows.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and an island, overlooking a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-117 W 20th St-5.jpg"
    },
    {
      "id": "ec_18f669f8b1bc84d518111250",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-e1ee-7700-8912-873484398a77.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, bedside table, and artwork.",
        "public_id": "01a01005-e1ee-7700-8912-873484398a77",
        "storage_key": "property/6767906449167655/01a01005-e1ee-7700-8912-873484398a77.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a king-size bed with plush bedding, a modern bedside table with a lamp, and contemporary artwork on the wall. The open doorway reveals a glimpse of another room.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, bedside table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-117 W 20th St-3_final.jpg"
    },
    {
      "id": "ec_e11530f4c4a75d0f05ca950a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-e66e-7545-a538-7531d63eeff4.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in a modern apartment with industrial-style finishes.",
        "public_id": "01a01005-e66e-7545-a538-7531d63eeff4",
        "storage_key": "property/6767906449167655/01a01005-e66e-7545-a538-7531d63eeff4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this apartment, featuring a dedicated dining area adjacent to a fully equipped kitchen. The open-concept design and industrial-chic finishes create a stylish and functional space.",
      "link": "false",
      "alt_text": "Dining area and kitchen in a modern apartment with industrial-style finishes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-117 W 20th St-1_final.jpg"
    },
    {
      "id": "ec_20c7bbe3018bcdfd92e83477",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-e6c4-76ba-897b-6f0be28fd2c9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
        "public_id": "01a01005-e6c4-76ba-897b-6f0be28fd2c9",
        "storage_key": "property/6767906449167655/01a01005-e6c4-76ba-897b-6f0be28fd2c9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Discover this sleek and functional kitchen, featuring stainless steel appliances, granite countertops, and stylish wood cabinetry. Perfect for any home chef!",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-117 W 20th St-2.jpg"
    },
    {
      "id": "ec_a1f0931748b59c359a47e457",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-e983-759a-9abb-10dac1ac4067.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a washer and dryer, vanity with a glass countertop, and a tiled bathtub/shower combo.",
        "public_id": "01a01005-e983-759a-9abb-10dac1ac4067",
        "storage_key": "property/6767906449167655/01a01005-e983-759a-9abb-10dac1ac4067.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish and functional bathroom featuring a stacked washer and dryer, a sleek vanity with a glass top, and a chic tiled bathtub and shower area.",
      "link": "false",
      "alt_text": "Modern bathroom with a washer and dryer, vanity with a glass countertop, and a tiled bathtub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-117 W 20th St-4.jpg"
    },
    {
      "id": "ec_531b0bb33025ef5565cc8223",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-e923-706d-9fca-b86755c81447.webp",
      "image_media": {
        "alt_text": "Spacious open-concept living area with a modern kitchen featuring stainless steel appliances and an island.",
        "public_id": "01a01005-e923-706d-9fca-b86755c81447",
        "storage_key": "property/6767906449167655/01a01005-e923-706d-9fca-b86755c81447.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience urban living in this stylish open-concept apartment. The sleek kitchen boasts stainless steel appliances and a convenient island, perfect for entertaining.",
      "link": "false",
      "alt_text": "Spacious open-concept living area with a modern kitchen featuring stainless steel appliances and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-117 W 20th St-10_final.jpg"
    },
    {
      "id": "ec_b79eda7486a41e932773a0fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-ee11-70fa-b660-cd80031e5a47.webp",
      "image_media": {
        "alt_text": "Spacious living room with large windows overlooking the city and an exposed brick accent wall.",
        "public_id": "01a01005-ee11-70fa-b660-cd80031e5a47",
        "storage_key": "property/6767906449167655/01a01005-ee11-70fa-b660-cd80031e5a47.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience urban living in this stylish apartment featuring a modern living area with city views, exposed brick, and ample natural light.",
      "link": "false",
      "alt_text": "Spacious living room with large windows overlooking the city and an exposed brick accent wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-117 W 20th St-9_final.jpg"
    },
    {
      "id": "ec_45214e806a7e733c058c48fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-f51e-713a-b4e9-43a56aff49a3.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines and cardio equipment, featuring a modern geometric mural on the wall.",
        "public_id": "01a01005-f51e-713a-b4e9-43a56aff49a3",
        "storage_key": "property/6767906449167655/01a01005-f51e-713a-b4e9-43a56aff49a3.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "false",
      "alt_text": "Fitness center with weight machines and cardio equipment, featuring a modern geometric mural on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Fitness Center 4.jpg"
    },
    {
      "id": "ec_6910fd4e6bba4f779fadc0a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-f586-77dc-8076-4b589b20ab73.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a fitness center with city views.",
        "public_id": "01a01005-f586-77dc-8076-4b589b20ab73",
        "storage_key": "property/6767906449167655/01a01005-f586-77dc-8076-4b589b20ab73.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with treadmills, ellipticals, and weight machines, offering stunning city views.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machines in a fitness center with city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Fitness Center 5.jpg"
    },
    {
      "id": "ec_5b7ec4371ee9785bd2d4fd7a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-f9d1-769d-8ff4-e4f572be6101.webp",
      "image_media": {
        "alt_text": "Convenience store with snacks and drinks",
        "public_id": "01a01005-f9d1-769d-8ff4-e4f572be6101",
        "storage_key": "property/6767906449167655/01a01005-f9d1-769d-8ff4-e4f572be6101.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Convenience store with a wide selection of snacks, drinks, and a coffee station.",
      "link": "false",
      "alt_text": "Convenience store with snacks and drinks",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Micro Market 1.jpg"
    },
    {
      "id": "ec_f3e3fad7e10aec77550232a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-fcee-740a-9616-7fc62f8ceb0d.webp",
      "image_media": {
        "alt_text": "Rooftop pool and lounge area with a city skyline view.",
        "public_id": "01a01005-fcee-740a-9616-7fc62f8ceb0d",
        "storage_key": "property/6767906449167655/01a01005-fcee-740a-9616-7fc62f8ceb0d.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy the stunning city skyline from our rooftop pool and lounge area. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Rooftop pool and lounge area with a city skyline view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6ea899b2-b624-4d62-82be-c177ee4b7a12.jpg"
    },
    {
      "id": "ec_b8c4349cd1b226db0b94b55a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-fe27-70cf-af6e-e07c290589f2.webp",
      "image_media": {
        "alt_text": "Staircase and lobby area with ",
        "public_id": "01a01005-fe27-70cf-af6e-e07c290589f2",
        "storage_key": "property/6767906449167655/01a01005-fe27-70cf-af6e-e07c290589f2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to the lobby of Piper Lofts at Crossroads, featuring a grand staircase and unique wooden accent wall.",
      "link": "false",
      "alt_text": "Staircase and lobby area with ",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-117 W 20th St-12.jpg"
    },
    {
      "id": "ec_9ada30b8a2a90af9b08ca7b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01006-0775-725d-b1f0-09446456b6c6.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building at dusk with a colorful sky.",
        "public_id": "01a01006-0775-725d-b1f0-09446456b6c6",
        "storage_key": "property/6767906449167655/01a01006-0775-725d-b1f0-09446456b6c6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "A stunning brick apartment building with large windows, illuminated at dusk under a vibrant pink and blue sky. The building's architecture showcases a blend of historic charm and modern appeal, set against a city streetscape.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building at dusk with a colorful sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-117 W 20th St-13.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0f24b418-42ac-44c2-b9b0-dfb83e811cf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Affäre",
      "poi_type": "Restaurants",
      "poi_address": "1911 Main St, Kansas City, MO 64108, USA",
      "poi_short_description": "Modern German plates in a posh space accented with dramatic lighting & contemporary art.",
      "poi_long_description": "Modern German plates in a posh space accented with dramatic lighting & contemporary art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-ec21-7181-9fea-091ba51fc98f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-ec21-7181-9fea-091ba51fc98f",
        "storage_key": "property/6767906449167655/019ff6bd-ec21-7181-9fea-091ba51fc98f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.affarekc.com/?y_source=1_MjA1NTY5NDc0NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15869239026382561012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "affre",
      "poi_latitude": "39.0900677",
      "poi_longitude": "-94.5834017",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-298-6182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5OU-kHwwIcR9F5Mz9DcOtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_60c8792e-b005-4b4e-ba1e-90e614139f0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Extra Virgin",
      "poi_type": "Restaurants",
      "poi_address": "1900 Main St, Kansas City, MO 64108, USA",
      "poi_short_description": "Well-known spot for inventive Mediterranean tapas in lively, festive digs with a streetside patio.",
      "poi_long_description": "Well-known spot for inventive Mediterranean tapas in lively, festive digs with a streetside patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a2-f468-756b-82f2-72086738f948.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a2-f468-756b-82f2-72086738f948",
        "storage_key": "property/6767906449167655/019ff6a2-f468-756b-82f2-72086738f948.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://www.extravirginkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6321131323208913767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "extra-virgin",
      "poi_latitude": "39.0902121",
      "poi_longitude": "-94.5840456",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-842-2205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZaq9kHwwIcRZ1N2mnIruVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_cad48cd2-9448-46ca-9afa-2116a306acd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Grünauer",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Austrian-German cooking & European beer in the historic dark-wood-&-brick Freight House space.",
      "poi_long_description": "Austrian-German cooking & European beer in the historic dark-wood-&-brick Freight House space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-1703-763a-ae6c-5a4d59495f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-1703-763a-ae6c-5a4d59495f22",
        "storage_key": "property/6767906449167655/019ff691-1703-763a-ae6c-5a4d59495f22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.grunauerkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11232384842969443421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grnauer",
      "poi_latitude": "39.0873431",
      "poi_longitude": "-94.5852782",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-283-3234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcRXeyswYBy4Zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "austrian_restaurant"
    },
    {
      "id": "custom_884047bb-3d77-4374-8b5e-812e97f6f690",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Lidia’s",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Celebrated upscale spot for Northern Italian dining in a glitzy locale with blown-glass chandeliers.",
      "poi_long_description": "Celebrated upscale spot for Northern Italian dining in a glitzy locale with blown-glass chandeliers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-1154-750a-8a04-346b939ae1f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-1154-750a-8a04-346b939ae1f6",
        "storage_key": "property/6767906449167655/019ff691-1154-750a-8a04-346b939ae1f6.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.lidias-kc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14489280469360899567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidias",
      "poi_latitude": "39.0877163",
      "poi_longitude": "-94.5847287",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-221-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcR7_VCw9FDFMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3c019474-ae05-4770-a376-1f508e360560",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Freight House",
      "poi_type": "Restaurants",
      "poi_address": "101 W 22nd St, Kansas City, MO 64108, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-d430-7708-9e08-0f7066d7c0ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-d430-7708-9e08-0f7066d7c0ee",
        "storage_key": "property/6767906449167655/019ff68d-d430-7708-9e08-0f7066d7c0ee.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=14717886139068817346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---freight-house",
      "poi_latitude": "39.0875678",
      "poi_longitude": "-94.5850052",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-472-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzokTUDwwIcRwp_X-3ZvQMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_46181f71-b885-46d3-98de-a4dde46393a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Grinders Pizza",
      "poi_type": "Restaurants",
      "poi_address": "417 E 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Hopping haunt with a laid-back vibe serving American grub such as thin-crust pies & grinders.",
      "poi_long_description": "Hopping haunt with a laid-back vibe serving American grub such as thin-crust pies & grinders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-7b24-74a2-90a6-26c5a849719e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-7b24-74a2-90a6-26c5a849719e",
        "storage_key": "property/6767906449167655/019ff6a3-7b24-74a2-90a6-26c5a849719e.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "http://www.grinderspizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6819665727325439585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grinders-pizza",
      "poi_latitude": "39.0914193",
      "poi_longitude": "-94.5781167",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-472-5454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ29SyTWnwwIcRYYYjzNhRpF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_42d13a73-8973-4b1c-a73a-6fe7501000bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Parlor",
      "poi_type": "Restaurants",
      "poi_address": "1707 Locust St, Kansas City, MO 64108, USA",
      "poi_short_description": "Modern food hall on 3 levels offering a variety of casual & creative dining options, plus 2 bars.",
      "poi_long_description": "Modern food hall on 3 levels offering a variety of casual & creative dining options, plus 2 bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a2-f530-75ae-86d0-ea7b188f18e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a2-f530-75ae-86d0-ea7b188f18e2",
        "storage_key": "property/6767906449167655/019ff6a2-f530-75ae-86d0-ea7b188f18e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.parlorkcmo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18079438753172310108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parlor",
      "poi_latitude": "39.0928287",
      "poi_longitude": "-94.5774633",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-875-4813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLffqCUbxwIcRXEhEzcER5_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_dd004832-3c91-4a6a-bac9-148d530deaf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "City Barrel Brewery + Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1740 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "Brewpub serving elevated pub grub & cocktails in an industrial-chic space with communal tables.",
      "poi_long_description": "Brewpub serving elevated pub grub & cocktails in an industrial-chic space with communal tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-f501-76bf-9c68-d255520e6cd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-f501-76bf-9c68-d255520e6cd6",
        "storage_key": "property/6767906449167655/019ff6bd-f501-76bf-9c68-d255520e6cd6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.citybarrelbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2235082811642613302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-barrel-brewery--kitchen",
      "poi_latitude": "39.0917428",
      "poi_longitude": "-94.5756008",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-298-7008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJewcQuFvxwIcRNg6Kp_mbBB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_7b84eafc-cf82-4d47-b29e-9005525526e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kobi Q",
      "poi_type": "Restaurants",
      "poi_address": "1531 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Open for lunch & dinner, this welcoming restaurant prepares freshly grilled Korean specials.",
      "poi_long_description": "Open for lunch & dinner, this welcoming restaurant prepares freshly grilled Korean specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-ed30-728f-a808-e8f53ad97b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-ed30-728f-a808-e8f53ad97b53",
        "storage_key": "property/6767906449167655/019ff6bd-ed30-728f-a808-e8f53ad97b53.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://kobi-q.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=49585291117927288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kobi-q",
      "poi_latitude": "39.0946997",
      "poi_longitude": "-94.5809845",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-702-8844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVXhYGjwwIcReBsrP48psAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_barbecue_restaurant"
    },
    {
      "id": "custom_7e3b5774-8948-4f5b-9e9c-0465825ec614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "The Rockhill Grille",
      "poi_type": "Restaurants",
      "poi_address": "2000 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "A sophisticated destination offering American plates and inventive cocktails in stylish surroundings. ",
      "poi_long_description": "A sophisticated destination offering American plates and inventive cocktails in stylish surroundings. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-1445-74a0-9fad-84a5c283b71f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-1445-74a0-9fad-84a5c283b71f",
        "storage_key": "property/6767906449167655/019ff691-1445-74a0-9fad-84a5c283b71f.webp",
        "width": 833,
        "height": 883
      },
      "poi_business_url": "http://www.therockhillgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=504493137268660927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rockhill-grille",
      "poi_latitude": "39.0888831",
      "poi_longitude": "-94.5816946",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-389-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo41rQmrwwIcRv1qF3tVRAAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_c1fa43cb-eea4-40fc-bca1-31f35c19fae3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Café Corazón",
      "poi_type": "Restaurants",
      "poi_address": "110 Southwest Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Latin-themed coffee shop serving espressos and smoothies, along with pastries and burritos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-f502-709d-88a2-b773f66192d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-f502-709d-88a2-b773f66192d0",
        "storage_key": "property/6767906449167655/019ff6bd-f502-709d-88a2-b773f66192d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cafecorazonkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5120778548731311415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-corazn",
      "poi_latitude": "39.0903386",
      "poi_longitude": "-94.5852477",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-301-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-6123-7231-a9ee-5ff626181ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-6123-7231-a9ee-5ff626181ec4",
        "storage_key": "property/6767906449167655/019ff691-6123-7231-a9ee-5ff626181ec4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtcUzstvxwIcRN_WRgvWoEEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_9efe5a4b-2bbe-4d8f-9793-9b4272651d2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Town Topic Hamburgers Baltimore",
      "poi_type": "Restaurants",
      "poi_address": "1900 W Baltimore Ave, Kansas City, MO 64108, USA",
      "poi_short_description": "Old-fashioned 24-hour diner, a Kansas City staple, featuring burgers and breakfasts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-ed15-76a1-bc3b-bf8de9e73b74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-ed15-76a1-bc3b-bf8de9e73b74",
        "storage_key": "property/6767906449167655/019ff6bd-ed15-76a1-bc3b-bf8de9e73b74.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.towntopic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4257048391842015310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-topic-hamburgers-baltimore",
      "poi_latitude": "39.0906861",
      "poi_longitude": "-94.5849361",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-471-6038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuWrUJ0LwwIcRTihkI_USFDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_0de3c72f-eea9-4a24-b29c-39b20e10c257",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Lulu's Thai Noodle Shop",
      "poi_type": "Restaurants",
      "poi_address": "2030 Central St, Kansas City, MO 64108, USA",
      "poi_short_description": "Hip, cheery outfit serves up hefty plates of eclectic Thai specialties, including lunch deals.",
      "poi_long_description": "Hip, cheery outfit serves up hefty plates of eclectic Thai specialties, including lunch deals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-1c82-7508-ad0a-fa51bc8c5fde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-1c82-7508-ad0a-fa51bc8c5fde",
        "storage_key": "property/6767906449167655/019ff691-1c82-7508-ad0a-fa51bc8c5fde.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lulusnoodles.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1635921864428077982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lulus-thai-noodle-shop",
      "poi_latitude": "39.08788029999999",
      "poi_longitude": "-94.5877957",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-474-8424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-q010bwwIcRnsOHqUT2sxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_69e1217d-ab3e-42e2-b32e-6c2b00b3918b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "La Bodega",
      "poi_type": "Restaurants",
      "poi_address": "703 Southwest Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Vibrant, colorful venue pairs Spanish tapas with wine, with sidewalk seating & happy-hour deals.",
      "poi_long_description": "Vibrant, colorful venue pairs Spanish tapas with wine, with sidewalk seating & happy-hour deals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-ee40-72db-9ae3-145d8bc2d486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-ee40-72db-9ae3-145d8bc2d486",
        "storage_key": "property/6767906449167655/019ff6bd-ee40-72db-9ae3-145d8bc2d486.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.labodegakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18083401983064516741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-bodega",
      "poi_latitude": "39.0850903",
      "poi_longitude": "-94.5928478",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-472-8272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c62-775c-b996-eb2c531f5749",
        "storage_key": "property/6767906449167655/019ff68e-0c62-775c-b996-eb2c531f5749.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq1LV_TfwwIcRhagnK0sm9fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spanish_restaurant"
    },
    {
      "id": "custom_0a7f055e-9441-49cf-a2a1-b219f1f65ae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Crossroads Arts District",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 W 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-ef0a-746f-a0e0-a7b9c9575987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-ef0a-746f-a0e0-a7b9c9575987",
        "storage_key": "property/6767906449167655/019ff6bd-ef0a-746f-a0e0-a7b9c9575987.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kccrossroads.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2812755081066606522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-arts-district",
      "poi_latitude": "39.0917591",
      "poi_longitude": "-94.5853634",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-719-0233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMx3E0OHxwIcRum8m99fpCCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_973f6235-0a8f-4a43-8e94-3ee2d8a81640",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "DGX",
      "poi_type": "Shopping & Retail",
      "poi_address": "1979 Main St, Kansas City, MO 64108, USA",
      "poi_short_description": "Convenience store offering a selection of everyday goods, such as produce, beer, and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-1f36-732a-ab63-342775825b4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-1f36-732a-ab63-342775825b4a",
        "storage_key": "property/6767906449167655/019ff691-1f36-732a-ab63-342775825b4a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/mo/kansas-city/21919",
      "poi_directions_map_url": "https://maps.google.com/?cid=7804250227791131756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dgx",
      "poi_latitude": "39.0896893",
      "poi_longitude": "-94.5835506",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-601-1880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-6119-718f-b565-596218224c48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-6119-718f-b565-596218224c48",
        "storage_key": "property/6767906449167655/019ff691-6119-718f-b565-596218224c48.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJy1cXVXvxwIcRbHTAxTtETmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_c457686b-ffb4-474c-a3d7-6d6256eba59c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy at University Health Behavioral Health",
      "poi_type": "Health and Wellness",
      "poi_address": "300 W 19 Terrace, Kansas City, MO 64108, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-008d-718f-89e8-1da794945720.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-008d-718f-89e8-1da794945720",
        "storage_key": "property/6767906449167655/019ff6a3-008d-718f-89e8-1da794945720.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-300+w+19th+terrace-kansas+city-mo-64108/id=16360",
      "poi_directions_map_url": "https://maps.google.com/?cid=948729974985631790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy-at-university-health-behavioral-health",
      "poi_latitude": "39.09037500000001",
      "poi_longitude": "-94.5876771",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-410-9272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-611b-74a9-9f66-74b771b7e41c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-611b-74a9-9f66-74b771b7e41c",
        "storage_key": "property/6767906449167655/019ff691-611b-74a9-9f66-74b771b7e41c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzRcJ_UPwwIcRLqjIuuKQKg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_076ae67e-dc58-44b2-8eee-06776a0ebb82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Cosentino's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10 E 13th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Downtown eatery and market carrying staples, organic produce and deli salads to go.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-1f32-77b8-82fa-b77e95a5fe15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-1f32-77b8-82fa-b77e95a5fe15",
        "storage_key": "property/6767906449167655/019ff691-1f32-77b8-82fa-b77e95a5fe15.webp",
        "width": 1280,
        "height": 869
      },
      "poi_business_url": "http://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4624231086112210795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-market",
      "poi_latitude": "39.0986917",
      "poi_longitude": "-94.5831143",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-595-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7f-710e-a033-5dfcb9774042",
        "storage_key": "property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cy7gF3wwIcRa38JL6yRLEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7206583e-c267-4cb9-a4b8-14f46e845e01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "20 E 5th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Airy market with indoor/outdoor stands of produce, baked goods, spices, flowers, crafts & jewelry.",
      "poi_long_description": "Airy market with indoor/outdoor stands of produce, baked goods, spices, flowers, crafts & jewelry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-21ed-722d-829e-2532fb6125dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-21ed-722d-829e-2532fb6125dd",
        "storage_key": "property/6767906449167655/019ff691-21ed-722d-829e-2532fb6125dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thecitymarketkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752651509944153819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-market",
      "poi_latitude": "39.1090172",
      "poi_longitude": "-94.5822776",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-842-1271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c6f-73c9-90c1-4799085d0b7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c6f-73c9-90c1-4799085d0b7e",
        "storage_key": "property/6767906449167655/019ff68e-0c6f-73c9-90c1-4799085d0b7e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxzC42YrwwIcR2_b1Aa87274",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_6dd10384-168a-4187-8904-46722963baf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Chinatown Food Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "202 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-f502-709d-88a2-baa247418294.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-f502-709d-88a2-baa247418294",
        "storage_key": "property/6767906449167655/019ff6bd-f502-709d-88a2-baa247418294.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/chinatownfoodmarketkc?",
      "poi_directions_map_url": "https://maps.google.com/?cid=14867239086550760609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chinatown-food-market",
      "poi_latitude": "39.1109488",
      "poi_longitude": "-94.5815074",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-472-6363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7f-710e-a033-5dfcb9774042",
        "storage_key": "property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c2ZIvwwIcRoTyp4C0LU84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_73621e66-c1ab-40c9-90f2-21991030a6b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Crossland International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "19 E 3rd St, Kansas City, MO 64106, USA",
      "poi_short_description": "International provisions and spices from Africa, the Caribbean and Latin America.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-f611-7389-9731-b10179b9ccd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-f611-7389-9731-b10179b9ccd9",
        "storage_key": "property/6767906449167655/019ff6bd-f611-7389-9731-b10179b9ccd9.webp",
        "width": 1119,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16387859379758441399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossland-international-market",
      "poi_latitude": "39.1097106",
      "poi_longitude": "-94.5825199",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-448-3004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7f-710e-a033-5dfcb9774042",
        "storage_key": "property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVMSNovwwIcRtyOOf0dfbeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2ee5e74c-4eaf-41c9-854e-d826c4c6fb71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Nature's Own Health Food Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "310 E 5th St, Kansas City, MO 64106, USA",
      "poi_short_description": "Small market offering local produce, groceries and beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-fa04-71c8-9863-f15b40af352d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-fa04-71c8-9863-f15b40af352d",
        "storage_key": "property/6767906449167655/019ff6bd-fa04-71c8-9863-f15b40af352d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.naturesownmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2437611016676500704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natures-own-health-food-market",
      "poi_latitude": "39.1093112",
      "poi_longitude": "-94.5798461",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-997-9420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7f-710e-a033-5dfcb9774042",
        "storage_key": "property/6767906449167655/019ff68e-0c7f-710e-a033-5dfcb9774042.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdWt1sPvwIcR4OSU_U0i1CE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5b0413a9-6a20-4e53-b4b6-636e0dbd1bd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "RAYGUN",
      "poi_type": "Shopping & Retail",
      "poi_address": "1803 Baltimore Ave, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-2011-777f-99fd-39cd1801912f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-2011-777f-99fd-39cd1801912f",
        "storage_key": "property/6767906449167655/019ff691-2011-777f-99fd-39cd1801912f.webp",
        "width": 1280,
        "height": 888
      },
      "poi_business_url": "https://www.raygunsite.com/collections/kansas-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=17840764814693192527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raygun",
      "poi_latitude": "39.0916225",
      "poi_longitude": "-94.5846003",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-800-0990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c6f-73c9-90c1-4799085d0b7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c6f-73c9-90c1-4799085d0b7e",
        "storage_key": "property/6767906449167655/019ff68e-0c6f-73c9-90c1-4799085d0b7e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWdYzPkLwwIcRT1MTFRMhl_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_afbbbf82-d132-4259-998f-17f62166157f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Crown Center Apothecary",
      "poi_type": "Shopping & Retail",
      "poi_address": "2450 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-fba2-72c3-a716-f02c859ba2e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-fba2-72c3-a716-f02c859ba2e0",
        "storage_key": "property/6767906449167655/019ff6bd-fba2-72c3-a716-f02c859ba2e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crowncenter.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=4650817444903444309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crown-center-apothecary",
      "poi_latitude": "39.0829871",
      "poi_longitude": "-94.5827657",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-471-2027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-6119-718f-b565-596218224c48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-6119-718f-b565-596218224c48",
        "storage_key": "property/6767906449167655/019ff691-6119-718f-b565-596218224c48.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJxcU3dxXwwIcRVd-oNtMFi0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_97366eee-746b-4ed6-86b1-27ce678acb09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Crossroads Charter Schools",
      "poi_type": "Education",
      "poi_address": "1011 Central St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-2758-748b-bbdc-5d7e0791b6d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-2758-748b-bbdc-5d7e0791b6d3",
        "storage_key": "property/6767906449167655/019ff691-2758-748b-bbdc-5d7e0791b6d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crossroadsschoolskc.org/central-street/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6411766330210918135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-charter-schools",
      "poi_latitude": "39.1019416",
      "poi_longitude": "-94.5868335",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-221-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLcKsll7wwIcR9x4In4Er-1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9c050de1-fbd7-466c-9d1c-692787734fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Crossroads Academy - Quality Hill",
      "poi_type": "Education",
      "poi_address": "1080 Washington St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-282c-7429-af49-615794ba3ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-282c-7429-af49-615794ba3ed4",
        "storage_key": "property/6767906449167655/019ff691-282c-7429-af49-615794ba3ed4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://crossroadsschoolskc.org/quality-hill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1739164144611189564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-academy---quality-hill",
      "poi_latitude": "39.1013279",
      "poi_longitude": "-94.5903971",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-221-3191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU0OrelnwwIcRPGOlNZPAIhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a18f6834-e84a-4954-a4fc-c9a970bbaf24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Crossroads Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "816 Broadway Blvd, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-356f-704c-a08f-21113ba917af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-356f-704c-a08f-21113ba917af",
        "storage_key": "property/6767906449167655/019ff691-356f-704c-a08f-21113ba917af.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://crossroadsschoolskc.org/preparatory-academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16843612352382056394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-preparatory-academy",
      "poi_latitude": "39.10401239999999",
      "poi_longitude": "-94.5884408",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-369-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6W7Sae7xwIcRyjcddjGIwOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2373a52e-2ade-41df-8114-92fac1159f79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Primitivo Garcia Elementary School",
      "poi_type": "Education",
      "poi_address": "1000 W 17 St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-2c73-76ad-b547-199fb1cb6d53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-2c73-76ad-b547-199fb1cb6d53",
        "storage_key": "property/6767906449167655/019ff691-2c73-76ad-b547-199fb1cb6d53.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://primitivogarcia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435885958455630198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primitivo-garcia-elementary-school",
      "poi_latitude": "39.0942702",
      "poi_longitude": "-94.595658",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-418-8725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGVAkzU_wwIcRdhk8zvy205A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_bd9c4998-701f-405b-a160-5a591d422444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Guadalupe Centers High School",
      "poi_type": "Education",
      "poi_address": "1524 The Paseo, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-2f21-77ce-94ec-9af2eab3c81e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-2f21-77ce-94ec-9af2eab3c81e",
        "storage_key": "property/6767906449167655/019ff691-2f21-77ce-94ec-9af2eab3c81e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gck12.org/o/gchs",
      "poi_directions_map_url": "https://maps.google.com/?cid=24987232870172367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guadalupe-centers-high-school",
      "poi_latitude": "39.0941329",
      "poi_longitude": "-94.5649491",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-471-2582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJebdehk7wwIcRz4Ylg8HFWAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2c64ec33-579b-4e98-854d-c1411ef292c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Guadalupe Centers Middle School",
      "poi_type": "Education",
      "poi_address": "2640 Belleview Ave, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gck12.org/o/gcms",
      "poi_directions_map_url": "https://maps.google.com/?cid=17917368728439762787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guadalupe-centers-middle-school",
      "poi_latitude": "39.0792008",
      "poi_longitude": "-94.5970508",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-472-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJldNQgU7wwIcRYy9YoO1Hp_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_21fadbfc-64a1-440b-8221-1b1fdfcdcee7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Lincoln College Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "2111 Woodland Ave, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-2e8d-751e-8440-0b5028f23a76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-2e8d-751e-8440-0b5028f23a76",
        "storage_key": "property/6767906449167655/019ff6a3-2e8d-751e-8440-0b5028f23a76.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kcpublicschools.org/lincoln",
      "poi_directions_map_url": "https://maps.google.com/?cid=18344651527781118227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-college-preparatory-academy",
      "poi_latitude": "39.0868216",
      "poi_longitude": "-94.5603885",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-418-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHXDSnZ_6wIcRE3G40V5Llf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6478e47b-2285-4b93-bd7f-4c49cb047ec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-e6d1-7520-994d-fa85cbd31ae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-e6d1-7520-994d-fa85cbd31ae7",
        "storage_key": "property/6767906449167655/019ff68d-e6d1-7520-994d-fa85cbd31ae7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7753b84f-d8fb-4e89-acf9-9b22bb5039e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kansas City Art Institute",
      "poi_type": "Education",
      "poi_address": "4415 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-2619-72fa-b562-8f7cd0040bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-2619-72fa-b562-8f7cd0040bdd",
        "storage_key": "property/6767906449167655/019ff6a3-2619-72fa-b562-8f7cd0040bdd.webp",
        "width": 705,
        "height": 670
      },
      "poi_business_url": "http://www.kcai.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3056374416396262313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-art-institute",
      "poi_latitude": "39.0466734",
      "poi_longitude": "-94.5834059",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-472-4852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJffVj1cHvwIcRqRvknVZsaio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4f0adc1b-0abe-41e3-bb79-2a77a06e9553",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kansas City University",
      "poi_type": "Education",
      "poi_address": "1750 Independence Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-d818-7107-90c4-b18e1270c520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-d818-7107-90c4-b18e1270c520",
        "storage_key": "property/6767906449167655/019ff68d-d818-7107-90c4-b18e1270c520.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "http://kansascity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16389816158537025495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-university",
      "poi_latitude": "39.1072822",
      "poi_longitude": "-94.5609759",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-654-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c7c-755a-bf2e-1f5098a1351d",
        "storage_key": "property/6767906449167655/019ff68e-0c7c-755a-bf2e-1f5098a1351d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg1greoD6wIcR14eOj_VSdOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cc7251a9-1106-470d-9277-98b4e944a938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-34b0-7369-988f-d1616b9dfaef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-34b0-7369-988f-d1616b9dfaef",
        "storage_key": "property/6767906449167655/019ff691-34b0-7369-988f-d1616b9dfaef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_e6b8e9d5-62bb-436a-97df-cd31e40ad27f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "National WWI Museum and Memorial",
      "poi_type": "Entertainment",
      "poi_address": "2 Memorial Dr, Kansas City, MO 64108, USA",
      "poi_short_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_long_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-35d4-720d-9f10-5dcac2f3eeb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-35d4-720d-9f10-5dcac2f3eeb8",
        "storage_key": "property/6767906449167655/019ff691-35d4-720d-9f10-5dcac2f3eeb8.webp",
        "width": 1280,
        "height": 1071
      },
      "poi_business_url": "https://www.theworldwar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469991631701161311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-wwi-museum-and-memorial",
      "poi_latitude": "39.080663",
      "poi_longitude": "-94.5860835",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-888-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c63-771c-a764-eedb7cf18c00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c63-771c-a764-eedb7cf18c00",
        "storage_key": "property/6767906449167655/019ff68e-0c63-771c-a764-eedb7cf18c00.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzAyJjzwwIcRXzXcqOrhTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c30bfc17-99d6-491a-acac-1a2be71bd672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-fe5f-71e0-9417-a9c478d341c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-fe5f-71e0-9417-a9c478d341c4",
        "storage_key": "property/6767906449167655/019ff68d-fe5f-71e0-9417-a9c478d341c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ed6-70c7-bcc6-09c5e941c53b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ed6-70c7-bcc6-09c5e941c53b",
        "storage_key": "property/6767906449167655/019ff68e-0ed6-70c7-bcc6-09c5e941c53b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_fe5221c6-1b9f-4edb-9fa1-d63811906ac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "T-Mobile Center",
      "poi_type": "Entertainment",
      "poi_address": "1407 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_long_description": "Indoor arena with nearly 20,000 seats hosts pro & college sporting events, big-name concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-dcf4-752e-a7a3-7c36499fb097.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-dcf4-752e-a7a3-7c36499fb097",
        "storage_key": "property/6767906449167655/019ff68d-dcf4-752e-a7a3-7c36499fb097.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.t-mobilecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12445204140955467076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-center",
      "poi_latitude": "39.0974667",
      "poi_longitude": "-94.5801529",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-949-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi31tv2fwwIcRRP3eijo_tqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ab910b21-6db4-4b30-882e-b09c2237a3ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "The Midland Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1228 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "Historic circa-1927 theater hosting live music & entertainment in an opulent space.",
      "poi_long_description": "Historic circa-1927 theater hosting live music & entertainment in an opulent space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-3163-75cf-865d-b8348e6570c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-3163-75cf-865d-b8348e6570c9",
        "storage_key": "property/6767906449167655/019ff691-3163-75cf-865d-b8348e6570c9.webp",
        "width": 720,
        "height": 580
      },
      "poi_business_url": "http://www.midlandkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=519383206880627892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-midland-theatre",
      "poi_latitude": "39.0988704",
      "poi_longitude": "-94.5839658",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-283-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-QNhV3wwIcRtExsXEY4NQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_c48f8f17-2a87-4e34-8100-f6501bee38cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Folly Theater",
      "poi_type": "Entertainment",
      "poi_address": "300 W 12th St, Kansas City, MO 64105, USA",
      "poi_short_description": "Elegant theater since 1900 showcasing theatrical & musical performances, plus other events.",
      "poi_long_description": "Elegant theater since 1900 showcasing theatrical & musical performances, plus other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-fde9-77cb-aaf6-e8672a80eb68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-fde9-77cb-aaf6-e8672a80eb68",
        "storage_key": "property/6767906449167655/019ff6bd-fde9-77cb-aaf6-e8672a80eb68.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://follytheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1659353997130338439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "folly-theater",
      "poi_latitude": "39.100252",
      "poi_longitude": "-94.5872139",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-474-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNxeXGVzwwIcRhxCUM6s1Bxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2ed79778-0863-4dbe-9d1a-a74e4f3d1b10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "SEA LIFE Kansas City Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd Ste 100, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_long_description": "Family-friendly exhibits featuring more than 5,000 sea creatures, plus a play area & group packages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-4d93-7248-bf1c-c7bfa613ef59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-4d93-7248-bf1c-c7bfa613ef59",
        "storage_key": "property/6767906449167655/019ff6a3-4d93-7248-bf1c-c7bfa613ef59.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.visitsealife.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590252280065768693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-kansas-city-aquarium",
      "poi_latitude": "39.0820805",
      "poi_longitude": "-94.5812573",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-471-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-e764-7485-a970-d02e7b528a3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a3-e764-7485-a970-d02e7b528a3e",
        "storage_key": "property/6767906449167655/019ff6a3-e764-7485-a970-d02e7b528a3e.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJtyRwuxXwwIcR9TwjjtSQlE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_139b4918-cea9-4458-9ab6-c3534e77a09b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "LEGOLAND Discovery Center Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd East Retail Suite 200; Crown Center Shops, Kansas City, MO 64108, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-3841-73a0-a628-a6f89f2c044b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-3841-73a0-a628-a6f89f2c044b",
        "storage_key": "property/6767906449167655/019ff691-3841-73a0-a628-a6f89f2c044b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7206990507281059484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-kansas-city",
      "poi_latitude": "39.08208190000001",
      "poi_longitude": "-94.5813858",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-556-3958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qq6ljwwIcRnI4Znq5fBGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_d018d5c6-ca73-4bd9-b095-3b4a6fc58413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "The Coterie Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2450 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Classic & contemporary theater with productions chosen to appeal to audiences of all ages.",
      "poi_long_description": "Classic & contemporary theater with productions chosen to appeal to audiences of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6bd-fe40-71db-a06c-0b70921e3e51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6bd-fe40-71db-a06c-0b70921e3e51",
        "storage_key": "property/6767906449167655/019ff6bd-fe40-71db-a06c-0b70921e3e51.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://thecoterie.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15553168065162065388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-coterie-theatre",
      "poi_latitude": "39.0820462",
      "poi_longitude": "-94.5822789",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-474-6552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcU3dxXwwIcR7DXvd_Pz19c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_a1cd5a98-7c7f-49c2-a668-060deb29b39e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "American Jazz Museum",
      "poi_type": "Entertainment",
      "poi_address": "1616 E 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Museum devoted to jazz music with live performances, educational programs & interactive exhibits.",
      "poi_long_description": "Museum devoted to jazz music with live performances, educational programs & interactive exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-4735-7448-997a-8e99ac5dca7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-4735-7448-997a-8e99ac5dca7e",
        "storage_key": "property/6767906449167655/019ff6a3-4735-7448-997a-8e99ac5dca7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://americanjazzmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12153190234996580988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-jazz-museum",
      "poi_latitude": "39.0914549",
      "poi_longitude": "-94.5629526",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-474-8463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c63-771c-a764-eedb7cf18c00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c63-771c-a764-eedb7cf18c00",
        "storage_key": "property/6767906449167655/019ff68e-0c63-771c-a764-eedb7cf18c00.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5V43AXbwwIcRfKK33CDOqKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5c0251fe-fea8-4ce8-a1c8-73e719db6d8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-5058-76cc-bcda-893c0ccdf811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-5058-76cc-bcda-893c0ccdf811",
        "storage_key": "property/6767906449167655/019ff691-5058-76cc-bcda-893c0ccdf811.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c63-771c-a764-ea3d59054f9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c63-771c-a764-ea3d59054f9d",
        "storage_key": "property/6767906449167655/019ff68e-0c63-771c-a764-ea3d59054f9d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0f67fa16-c07a-4825-8857-0dd18e547139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-f5d1-778d-adf4-e0323d068f34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-f5d1-778d-adf4-e0323d068f34",
        "storage_key": "property/6767906449167655/019ff68d-f5d1-778d-adf4-e0323d068f34.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c63-771c-a764-ea3d59054f9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c63-771c-a764-ea3d59054f9d",
        "storage_key": "property/6767906449167655/019ff68e-0c63-771c-a764-ea3d59054f9d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0cc7c221-93fa-4cdf-8010-4f8a50701be2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "The University of Kansas Health System Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1403 Grand Blvd, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-0091-709f-99f4-d604dbca4c37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-0091-709f-99f4-d604dbca4c37",
        "storage_key": "property/6767906449167655/019ff6be-0091-709f-99f4-d604dbca4c37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kansashealthsystem.com/urgentcare",
      "poi_directions_map_url": "https://maps.google.com/?cid=11959568068617776220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-kansas-health-system-urgent-care",
      "poi_latitude": "39.0978149",
      "poi_longitude": "-94.5802354",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-574-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7oHt2fwwIcRXCwRPcvr-KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_1c7c65e8-3513-4a96-887f-344eae7cb6e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "200 Southwest Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-3a86-7004-8079-31a4e975d032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-3a86-7004-8079-31a4e975d032",
        "storage_key": "property/6767906449167655/019ff691-3a86-7004-8079-31a4e975d032.webp",
        "width": 739,
        "height": 415
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3129459642490607473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "39.0896959",
      "poi_longitude": "-94.5862944",
      "poi_miles_from_property": "0.09",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-842-1146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwdYbcEHwwIcRcdeS2fYSbis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9200cbc6-1510-4f32-9b7b-9ed73a053419",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "921 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-1da3-760a-84b6-e02bd00886d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-1da3-760a-84b6-e02bd00886d3",
        "storage_key": "property/6767906449167655/019ff691-1da3-760a-84b6-e02bd00886d3.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/kansas-city-mo-pharmacies/921-main-street-kansas-city-mo-64105/storeid=8592?WT.mc_id=LS_GOOGLE_RX_8592",
      "poi_directions_map_url": "https://maps.google.com/?cid=3354058715846669665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.10253429999999",
      "poi_longitude": "-94.5829035",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-842-2514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-611b-74a9-9f66-74b771b7e41c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-611b-74a9-9f66-74b771b7e41c",
        "storage_key": "property/6767906449167655/019ff691-611b-74a9-9f66-74b771b7e41c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWb6m2DwwIcRYfXXqaECjC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_367d35d4-26aa-478b-ae22-0c0724e109af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy at University Health Truman Medical Ctr.",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-2e10-769b-bcc2-e03fe320d1e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-2e10-769b-bcc2-e03fe320d1e3",
        "storage_key": "property/6767906449167655/019ff691-2e10-769b-bcc2-e03fe320d1e3.webp",
        "width": 1280,
        "height": 905
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2301+holmes+st-kansas+city-mo-64108/id=10845",
      "poi_directions_map_url": "https://maps.google.com/?cid=2122014859472525265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy-at-university-health-truman-medical-ctr",
      "poi_latitude": "39.0844879",
      "poi_longitude": "-94.5752976",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-471-2072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-611b-74a9-9f66-74b771b7e41c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-611b-74a9-9f66-74b771b7e41c",
        "storage_key": "property/6767906449167655/019ff691-611b-74a9-9f66-74b771b7e41c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2S-3xLwwIcR0df1kkXpch0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_dd5f5e0c-77bf-4ba7-ac58-87b33b21d12a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Sequence Climb",
      "poi_type": "Health and Wellness",
      "poi_address": "1710 Washington St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-1dfc-742c-80ec-90a248efe1cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-1dfc-742c-80ec-90a248efe1cc",
        "storage_key": "property/6767906449167655/019ff6be-1dfc-742c-80ec-90a248efe1cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://sequenceclimb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9434279458090644873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sequence-climb",
      "poi_latitude": "39.0924453",
      "poi_longitude": "-94.5900461",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-944-3936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzf6_szxwIcRifVBoy5L7YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_fd133665-c9de-420a-a6c7-37b1d34a0bf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "F45 Training Crossroads KC",
      "poi_type": "Health and Wellness",
      "poi_address": "1827 Walnut St, Kansas City, MO 64108, USA",
      "poi_short_description": "Friendly fitness studio for intense circuit training, featuring weights, music and teams.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-3bc8-71f9-aff8-7a7507db59df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-3bc8-71f9-aff8-7a7507db59df",
        "storage_key": "property/6767906449167655/019ff691-3bc8-71f9-aff8-7a7507db59df.webp",
        "width": 948,
        "height": 533
      },
      "poi_business_url": "https://f45training.com/crossroadskc/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=18172217301083143991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-crossroads-kc",
      "poi_latitude": "39.0907918",
      "poi_longitude": "-94.5821374",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-631-9703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdU99mnwwIcRN79E1FqvMPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0664aba4-4111-4e26-a4f2-f21df2cda173",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1706 Baltimore Ave, Kansas City, MO 64108, USA",
      "poi_short_description": "Heart rate-based group workout using cardio and strength-training exercises.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-4121-7006-a7e2-621eb1990816.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-4121-7006-a7e2-621eb1990816",
        "storage_key": "property/6767906449167655/019ff691-4121-7006-a7e2-621eb1990816.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/kansas-city-missouri-1167?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=4872878791804400293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "39.092476",
      "poi_longitude": "-94.5848958",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-659-1055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UhBrhvxwIcRpTIJi3Hxn0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fac21052-8a36-4406-bb05-2453da929cf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Power & Light",
      "poi_type": "Health and Wellness",
      "poi_address": "1261 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "Spacious, clean gym offering a range of classes, equipment and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-ec01-77bb-b322-b4ae37c6e1e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-ec01-77bb-b322-b4ae37c6e1e8",
        "storage_key": "property/6767906449167655/019ff68d-ec01-77bb-b322-b4ae37c6e1e8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/power-light.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5275511582065765821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---power--light",
      "poi_latitude": "39.0991682",
      "poi_longitude": "-94.5830873",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-268-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2cpfF3wwIcRvS19QdVhNkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d2a5d3ec-604d-4c1e-9f9d-680b447a4fca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Grinders KC Event Venue - Box Office + GA Gate",
      "poi_type": "Entertainment",
      "poi_address": "1826 Locust St, Kansas City, MO 64108, USA",
      "poi_short_description": "Relaxed outdoor venue for concerts and festivals featuring local and national acts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-00ba-72be-9cdc-9300d3062402.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-00ba-72be-9cdc-9300d3062402",
        "storage_key": "property/6767906449167655/019ff6be-00ba-72be-9cdc-9300d3062402.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.grinderskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7478014108669537786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grinders-kc-event-venue---box-office--ga-gate",
      "poi_latitude": "39.0910659",
      "poi_longitude": "-94.5781841",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-666-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeUaDR7xwIcR-m2bLDY-x2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_4a3f8272-e113-42cf-bc7e-e0841286d82b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Penn Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 29th Street, Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_long_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-f43b-7749-91aa-c41dfd1ca3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-f43b-7749-91aa-c41dfd1ca3e9",
        "storage_key": "property/6767906449167655/019ff68d-f43b-7749-91aa-c41dfd1ca3e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/penn-valley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561286278733833014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-valley-park",
      "poi_latitude": "39.0757432",
      "poi_longitude": "-94.588766",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcMmnDvwwIcRNiMXXGzL9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b4b6b8cd-b14e-4ad2-b213-b949a13bf112",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Henry Wollman Bloch Fountain",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "Landmark fountain featuring 232 jets of water set to a timed display, with colorful lights at night.",
      "poi_long_description": "Landmark fountain featuring 232 jets of water set to a timed display, with colorful lights at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-056b-75fd-9e93-119a03da0d6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-056b-75fd-9e93-119a03da0d6b",
        "storage_key": "property/6767906449167655/019ff6be-056b-75fd-9e93-119a03da0d6b.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "https://kcparks.org/places/bloch-henry-wollman-fountain-2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2746495984020261735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-wollman-bloch-fountain",
      "poi_latitude": "39.0838478",
      "poi_longitude": "-94.5849493",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ81ZVoj_wwIcRZ4uQwIuDHSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ad7e03e2-ed78-46de-916b-afb2fcdec37f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Ermine Case Junior Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "905 Jefferson St, Kansas City, MO 64105, USA",
      "poi_short_description": "City park featuring a playground, picnic tables, and views of the river and airport.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-68d1-759d-b7f0-e1429920309f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-68d1-759d-b7f0-e1429920309f",
        "storage_key": "property/6767906449167655/019ff6a3-68d1-759d-b7f0-e1429920309f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://kcparks.org/park/case-ermine-jr-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7298072921242486857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ermine-case-junior-park",
      "poi_latitude": "39.1049619",
      "poi_longitude": "-94.5923131",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YtiLljwwIcRSUiOr6f2R2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_61eff8be-1127-4a65-9ab7-9b584231e3b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "City Market Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300-398 Main St, Kansas City, MO 64105, USA",
      "poi_short_description": "City Market park featuring produce vendors, live music, restaurants, and local artists.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-0882-7728-a7be-5977cc7f37b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-0882-7728-a7be-5977cc7f37b2",
        "storage_key": "property/6767906449167655/019ff6be-0882-7728-a7be-5977cc7f37b2.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16153869327600272507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-market-park",
      "poi_latitude": "39.1095212",
      "poi_longitude": "-94.5835627",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-423-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZ76zvTwwIcRe0SxC5ESLuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_47aeb860-bf77-4402-9bc6-014f6b5b87c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "River Market Off-Leash Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "419-499 Locust Ln, Kansas City, MO 64106, USA",
      "poi_short_description": "Public park featuring a grassy area and shade trees for dogs to roam and play.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-9932-71c9-b2fe-bb826209e3be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-9932-71c9-b2fe-bb826209e3be",
        "storage_key": "property/6767906449167655/019ff6a3-9932-71c9-b2fe-bb826209e3be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/rivermarketOLA/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7713914372543571035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-market-off-leash-dog-park",
      "poi_latitude": "39.1099539",
      "poi_longitude": "-94.5779015",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB3DjYYnwwIcRW2Q9c0BUDWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_77e1dea7-c307-496d-a3e6-80c0d4cc8be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Mulkey Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 Summit St, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-09f7-770a-a8b9-9e61925aa5e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-09f7-770a-a8b9-9e61925aa5e9",
        "storage_key": "property/6767906449167655/019ff6be-09f7-770a-a8b9-9e61925aa5e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kcparks.org/places/mulkey-square/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17646417750968350706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mulkey-square-park",
      "poi_latitude": "39.0985023",
      "poi_longitude": "-94.5944858",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYYvX5oLxwIcR8redJHOr5PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_093464d4-360d-4bc9-b4b2-765995d7bdd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Berkley Riverfront",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 Riverfront Dr, Kansas City, MO 64120, USA",
      "poi_short_description": "Downtown green space along the Missouri River features broad biking & walking paths & open fields.",
      "poi_long_description": "Downtown green space along the Missouri River features broad biking & walking paths & open fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-f4f8-733c-8f58-8aa30bf5f09e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-f4f8-733c-8f58-8aa30bf5f09e",
        "storage_key": "property/6767906449167655/019ff68d-f4f8-733c-8f58-8aa30bf5f09e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://berkleyriverfront.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3315902073752463479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berkley-riverfront",
      "poi_latitude": "39.1168217",
      "poi_longitude": "-94.5726106",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-559-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2yvAJDwwIcRdyj_H15zBC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7202933e-9117-45c6-8514-db2d50d17866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Loose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Wornall Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_long_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-f234-75d9-b878-cab8febc2981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-f234-75d9-b878-cab8febc2981",
        "storage_key": "property/6767906449167655/019ff68d-f234-75d9-b878-cab8febc2981.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/loose-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009609457171665569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loose-park",
      "poi_latitude": "39.0313445",
      "poi_longitude": "-94.5944237",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ecb-7652-a542-d9276f2c8128",
        "storage_key": "property/6767906449167655/019ff68e-0ecb-7652-a542-d9276f2c8128.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUf-8Na_vwIcRoZJ_Snj9yZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_91f49917-b3ff-48da-a1bd-d51a9874de0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Crossroads on Main at 19th St SB",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-0939-753b-8763-2cabb9fd0694.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-0939-753b-8763-2cabb9fd0694",
        "storage_key": "property/6767906449167655/019ff6be-0939-753b-8763-2cabb9fd0694.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kcstreetcar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6372887193508172484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-on-main-at-19th-st-sb",
      "poi_latitude": "39.0906437",
      "poi_longitude": "-94.5835717",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-613a-7344-adf1-ca707e08c2bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-613a-7344-adf1-ca707e08c2bd",
        "storage_key": "property/6767906449167655/019ff691-613a-7344-adf1-ca707e08c2bd.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wdfAkLwwIcRxNKwMiMLcVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_04f61704-a45a-44d9-8602-00339ab78d24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "East Village Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-8d8b-765d-bbe7-5f08b688eab2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-8d8b-765d-bbe7-5f08b688eab2",
        "storage_key": "property/6767906449167655/019ff6a3-8d8b-765d-bbe7-5f08b688eab2.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512695178041122718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-village-transit-center",
      "poi_latitude": "39.0994481",
      "poi_longitude": "-94.5736732",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-221-0660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVzzDLhPxwIcRnl9yw8bgKOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_d1468768-3e0e-43a3-80a2-06d53bfaca9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Troost Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-4580-70ef-8ee0-d71a9d6394ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-4580-70ef-8ee0-d71a9d6394ce",
        "storage_key": "property/6767906449167655/019ff691-4580-70ef-8ee0-d71a9d6394ce.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/kansas-city-mo/kansas-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16685443334022975407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "39.1000335",
      "poi_longitude": "-94.5693013",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWy-YvXvwwIcRr09ZHE-ajuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_1b158b91-6b06-4e96-baa3-2c062a5947b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "BikeWalkKC",
      "poi_type": "Transportation & Transit",
      "poi_address": "1106 E 30th St Ste G, Kansas City, MO 64109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-5962-715e-b1cf-6447ad2f5b81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-5962-715e-b1cf-6447ad2f5b81",
        "storage_key": "property/6767906449167655/019ff691-5962-715e-b1cf-6447ad2f5b81.webp",
        "width": 1280,
        "height": 790
      },
      "poi_business_url": "http://www.bikewalkkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1500022561484279170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bikewalkkc",
      "poi_latitude": "39.0723805",
      "poi_longitude": "-94.5706683",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-205-7056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR25bmPLxwIcRgo1XfJIm0RQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_bd572e27-e877-4770-92c2-48861c22d835",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-4c74-720d-b37a-f2157c6e77bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-4c74-720d-b37a-f2157c6e77bb",
        "storage_key": "property/6767906449167655/019ff691-4c74-720d-b37a-f2157c6e77bb.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "22",
      "poi_walking_minutes": "8 hours 13 mins",
      "poi_biking_minutes": "2 hours 43 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ed6-70c7-bcc6-074d61f831bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ed6-70c7-bcc6-074d61f831bc",
        "storage_key": "property/6767906449167655/019ff68e-0ed6-70c7-bcc6-074d61f831bc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_88202277-040a-435b-bd91-d56822885eb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kansas City Airport - Wheeler Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 Richards Rd, Kansas City, MO 64116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-f8e1-7445-a4f5-b2bdd99436f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-f8e1-7445-a4f5-b2bdd99436f3",
        "storage_key": "property/6767906449167655/019ff68d-f8e1-7445-a4f5-b2bdd99436f3.webp",
        "width": 1280,
        "height": 509
      },
      "poi_business_url": "http://www.flymkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6917393415046749860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-airport---wheeler-field",
      "poi_latitude": "39.1199859",
      "poi_longitude": "-94.5943256",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-859-7601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ed6-70c7-bcc6-074d61f831bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ed6-70c7-bcc6-074d61f831bc",
        "storage_key": "property/6767906449167655/019ff68e-0ed6-70c7-bcc6-074d61f831bc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJybRbhejwwIcRpN58O6mE_18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_93cc57e5-dd2a-4141-a0d8-e0b25dc7d833",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "On 85th at Holmes EB",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4382741315298936131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-85th-at-holmes-eb",
      "poi_latitude": "38.973706",
      "poi_longitude": "-94.58067",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-613a-7344-adf1-ca707e08c2bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff691-613a-7344-adf1-ca707e08c2bd",
        "storage_key": "property/6767906449167655/019ff691-613a-7344-adf1-ca707e08c2bd.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJKzyRTbbowIcRQ0XSaAGg0jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_64b2a8fc-e18a-4930-9595-21317ec978e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "One Main Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4435 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-0fe9-744d-bfc1-dd7e0a68e0bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-0fe9-744d-bfc1-dd7e0a68e0bc",
        "storage_key": "property/6767906449167655/019ff6be-0fe9-744d-bfc1-dd7e0a68e0bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6253421470572243082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-main-plaza",
      "poi_latitude": "39.0466613",
      "poi_longitude": "-94.5861282",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7xRG8HvwIcRimhCCLKdyFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_b50d1344-336a-42fe-9350-66fb485536d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Kansas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Kansas City City Hall, 414 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68d-fdbb-7058-a35b-2fde53d9cb8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68d-fdbb-7058-a35b-2fde53d9cb8c",
        "storage_key": "property/6767906449167655/019ff68d-fdbb-7058-a35b-2fde53d9cb8c.webp",
        "width": 781,
        "height": 1280
      },
      "poi_business_url": "http://www.kcmo.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16264843786418924934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-hall",
      "poi_latitude": "39.1008473",
      "poi_longitude": "-94.5780724",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ef2-7669-af66-c4710ffde1e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ef2-7669-af66-c4710ffde1e3",
        "storage_key": "property/6767906449167655/019ff68e-0ef2-7669-af66-c4710ffde1e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e-zp2bwwIcRhi24uD9VuOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_f193bf7f-3b62-4089-88c9-9a23bcdb7614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Jackson County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "415 E 12th St Unit 300, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6a3-ac58-71db-8bd6-cf99324dac4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-ac58-71db-8bd6-cf99324dac4c",
        "storage_key": "property/6767906449167655/019ff6a3-ac58-71db-8bd6-cf99324dac4c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jacksongov.org/Directory.aspx?did=4",
      "poi_directions_map_url": "https://maps.google.com/?cid=1955781323409348683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jackson-county-courthouse",
      "poi_latitude": "39.0992524",
      "poi_longitude": "-94.5781727",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-881-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ef2-7669-af66-c4710ffde1e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ef2-7669-af66-c4710ffde1e3",
        "storage_key": "property/6767906449167655/019ff68e-0ef2-7669-af66-c4710ffde1e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbRUnWbwwIcRS1goYMBUJBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_665f95e4-0fbc-4923-8884-63bd8b28e3fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "H&R Block",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One H and R, Block Way, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-497b-7340-80aa-fe1ed8d7584b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-497b-7340-80aa-fe1ed8d7584b",
        "storage_key": "property/6767906449167655/019ff691-497b-7340-80aa-fe1ed8d7584b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hrblock.com/tax-offices/local/missouri-tax-preparation/kansas-city-tax-professionals/?otppartnerid=9308&campaignid=pw_mcm_9308_9762&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17520317420083081084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hr-block",
      "poi_latitude": "39.0982642",
      "poi_longitude": "-94.5829906",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-854-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8i63JCKwIcRfO8j8N2rJPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_1b6c7b13-0ef3-4e26-af3a-0c4eb1e0e230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Shook, Hardy & Bacon L.L.P.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2555 Grand Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-1367-73dc-b9c8-86c393267988.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-1367-73dc-b9c8-86c393267988",
        "storage_key": "property/6767906449167655/019ff6be-1367-73dc-b9c8-86c393267988.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.shb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7919548204795275217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shook-hardy--bacon-llp",
      "poi_latitude": "39.0798302",
      "poi_longitude": "-94.5827487",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-474-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZDs9T3wwIcR0adn-CHj520",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_76602029-9aca-47ba-a8b3-8f592eef7f96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Lathrop GPM LLP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2323 Grand Blvd Ste 800, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-0db3-71cc-9526-173c8f891b7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-0db3-71cc-9526-173c8f891b7c",
        "storage_key": "property/6767906449167655/019ff6be-0db3-71cc-9526-173c8f891b7c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lathropgpm.com/offices-kansascity.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1601094896288281744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lathrop-gpm-llp",
      "poi_latitude": "39.0859394",
      "poi_longitude": "-94.5812794",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-292-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8Epy2rwwIcRkDT0QFM7OBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lawyer"
    },
    {
      "id": "custom_c896687a-e131-4120-895d-403d4563373d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-03f0-7698-a20f-336efeee56ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff68e-03f0-7698-a20f-336efeee56ec",
        "storage_key": "property/6767906449167655/019ff68e-03f0-7698-a20f-336efeee56ec.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_009e320d-290e-45aa-8d49-e5ec2f9fd5c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "Federal Reserve Bank of Kansas City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Memorial Dr, Kansas City, MO 64198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff691-4a96-722b-be84-d5a333f26825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff691-4a96-722b-be84-d5a333f26825",
        "storage_key": "property/6767906449167655/019ff691-4a96-722b-be84-d5a333f26825.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kansascityfed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17710993233906432888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-kansas-city",
      "poi_latitude": "39.0753294",
      "poi_longitude": "-94.5858203",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-333-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0ef2-7669-af66-c4710ffde1e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0ef2-7669-af66-c4710ffde1e3",
        "storage_key": "property/6767906449167655/019ff68e-0ef2-7669-af66-c4710ffde1e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9xf5TzwwIcRePtWZoIWyvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_abc54556-ab96-4690-8f16-cd1e23db440b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "poi_name": "American Century Investments",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4400 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff6be-1051-75d3-8b9d-c033bea8f0d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6be-1051-75d3-8b9d-c033bea8f0d2",
        "storage_key": "property/6767906449167655/019ff6be-1051-75d3-8b9d-c033bea8f0d2.webp",
        "width": 1280,
        "height": 389
      },
      "poi_business_url": "https://www.americancentury.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5277441427661296472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-century-investments",
      "poi_latitude": "39.0459098",
      "poi_longitude": "-94.5874404",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-531-5575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff68e-0c85-770b-b2a7-f30194660b6d",
        "storage_key": "property/6767906449167655/019ff68e-0c85-770b-b2a7-f30194660b6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ciW3sDvwIcRWJOucgQ9PUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8736de221ba1b8834987b609",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_f0b1f53e7b54e043a9c73f70",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "MON",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_916df9c3759f5c70adcc195f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_4d9e7c94ef1d27eecdc21bc6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "TUE",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_06dc306bd333d540fcc32c01",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_f42dc0e94c04f2e8099fedec",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "WED",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_3266b75811277e8bc19e4007",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_e96965b0a6891155e9cb5466",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "THU",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_a0fc7bbd4e4cf5def54440e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "12:00"
    },
    {
      "id": "ec_083cbecc1c946574391fca50",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "day": "FRI",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d55e333b9a4c2b2094ee5741",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "rating": "5",
      "name": "Robin Daniels",
      "text": "I just recently moved into Piper Lofts but have had the easiest and best experience possible! The property manager, April, is just amazing. I go downstairs just to say hi and chat with her. She is always so friendly and has been since day one. She is there for whatever I need and is always so responsive even in the evenings when I have questions that may be silly. As a new resident and first time renter, it is so refreshing to always have a smiling face and someone who is always happy to see you. She is the absolute best and I hope she is at Piper Lofts for a long time 😊",
      "date": "2026-01-21",
      "title": "false"
    },
    {
      "id": "ec_421fdb783f7e9c268cd82220",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "rating": "5",
      "name": "Linda Henry",
      "text": "The Charcuterie and Wine party was great.  Everyone was having a great time meeting others in the building.  As always, April was a great hostess for this event.  Can’t wait to see what events are coming up. Thank you for events where tenants can come together.",
      "date": "2026-01-23",
      "title": "false"
    },
    {
      "id": "ec_b5d7ba37ed0aca50ed052b5b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "rating": "5",
      "name": "Luke",
      "text": "Such a wonderful apartment complex! I lived there under old management and when new management took over, and I gotta say the new management is stellar. I noticed how they improved everything and it really made me wish I could stay. They added a cute little dog park, a doggy washing station, Thursday drinks, better doors, instructions on how to get the leasing office, really awesome new blinds in all the apartments, I could go on. I can tell they really care, which I appreciate. Even in one instance where I sent some grumpy emails to April because of some miscommunication on things, April responded back kindly. I can tell they care about the tenants and want to take care of them. That alone is worth living here for. Sad to leave. If you can afford here, I’d say it’s a great place to live!",
      "date": "2025-09-04",
      "title": "false"
    },
    {
      "id": "ec_8fc0327753973264ee57df03",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "rating": "5",
      "name": "Tatiana Darby",
      "text": "I am coming up on my year since moving into to Piper and I don't think I can even express how grateful I am to have found this home! One of the hardest things about finding a place in KC that checked out all my boxes was finding a place that would accept my sweet 10 year old French Mastiff. Because of his size and breed most places don't give him a chance with their weight and breed restrictions. He is a gentle giant and has LOVED his home here at Piper. Whenever I take him for a walk he always pulls me right to the office because he knows his pal, Tiffany, will be there waiting for him with lots of treats! There are so many friends for him to play with here at Piper too. All the Piper dogs, and their humans of course, are truly the best! Anyone looking not only for a great new home for them but their beloved furry friends too, this is the place to be!! Mars will be eager to greet you when you come in!",
      "date": "2021-03-24",
      "title": "false"
    },
    {
      "id": "ec_b7e3cbea4f6217fc8e3ef140",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "rating": "5",
      "name": "Brenna Winn",
      "text": "Best lofts in KC!!! Piper Lofts has been my favorite home in Kansas City. The units are very spacious with massive windows that offer great views of the city AND the amenities are 10/10. The building has private parking, a newly renovated gym, a small convenience store and a rooftop pool that overlooks downtown KC. It’s also in a perfect location in the Crossroads with bars and restaurants in walking distance in any direction!\n\nTiffany and the Piper team are also incredible to work with and have gone above and beyond for me. I’d highly recommend Piper Lofts over any residence in the KC downtown area!!",
      "date": "2024-02-13",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_d914418c605d4b932e87118f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "1-bedroom loft in the Crossroads at Piper Lofts in Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01006-4a88-736c-8a8e-5c438c9326ba.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01006-4a88-736c-8a8e-5c438c9326ba",
        "storage_key": "property/6767906449167655/01a01006-4a88-736c-8a8e-5c438c9326ba.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FRxVaTeokLS"
    },
    {
      "id": "ec_7ddf153c635be61ad95f960f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01006-4b24-751a-85d8-8afad89fd45e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01006-4b24-751a-85d8-8afad89fd45e",
        "storage_key": "property/6767906449167655/01a01006-4b24-751a-85d8-8afad89fd45e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ynz8xL5TMFk"
    },
    {
      "id": "ec_c05e520243712e7997cb14ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "2-bedroom loft in the Crossroads at Piper Lofts in Kansas City.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01006-4c2e-71d9-834b-423543e4991c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01006-4c2e-71d9-834b-423543e4991c",
        "storage_key": "property/6767906449167655/01a01006-4c2e-71d9-834b-423543e4991c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2D7G2c3y4UE"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a01039-f502-755b-8482-73c7feab1beb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Piper Lofts Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655"
    },
    {
      "lead_collector_id": "01a01039-f587-70cd-891e-79234e4437fc",
      "lead_source": "LANDING_PAGE",
      "name": "Piper Lofts Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "modern-loft-apartments-in-unit-laundry-kansas-city",
      "search_query": "modern loft apartments with in-unit laundry Kansas City",
      "category": "Amenity",
      "h1_title": "Modern Loft Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover modern loft apartments in Kansas City's heart. Experience in-unit laundry plus lavish finishes in the historic Crossroads District.",
      "page_copy": "Welcome to Piper Lofts, where historic charm meets modern convenience in the Crossroads of Kansas City. Our modern loft apartments with in-unit laundry provide all the comforts you need while offering an unmatched downtown lifestyle. Featuring exposed brick, soaring ceilings, and concrete floors, you'll fall in love with our open floor plans that beautifully integrate historic craftsmanship with contemporary design. \n\nPiper Lofts goes beyond just a place to live, offering a vibrant rooftop terrace and a community right in the heart of the city. Each unit boasts stainless steel appliances, granite countertops, and an island kitchen, ensuring the perfect blend of style and functionality. With maintenance on site, we ensure that your experience is smooth and hassle-free. Experience a new standard of living at Piper Lofts, where modern loft style meets convenience with in-unit laundry facilities, all just steps away from the energy of Kansas City's Crossroads neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Loft Apartments with In-Unit Laundry",
      "seo_description": "Explore modern loft apartments in Kansas City's Crossroads neighborhood with in-unit laundry. Experience sophisticated living at Piper Lofts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "luxury-apartments-air-conditioning-crossroads",
      "search_query": "luxury apartments with air conditioning Crossroads",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Air Conditioning",
      "h2_subtitle": "Experience luxury apartments with air conditioning in Crossroads, Kansas City. Enjoy modern amenities in a vibrant, historic setting.",
      "page_copy": "Discover the unique blend of history and modernity at Piper Lofts, offering luxury apartments with air conditioning located in the vibrant Crossroads district of Kansas City. Our beautifully designed one-, two-, and three-bedroom lofts feature high ceilings, exposed brick, and polished finishes that define upscale living. \n\nEach apartment is thoughtfully equipped with air conditioning, ensuring comfort throughout all seasons. Enjoy the convenience of stainless steel appliances, granite countertops, and island kitchens while soaking in panoramic downtown views. With on-site maintenance and a spectacular roof terrace, Piper Lofts not only meets but exceeds the demands of modern luxury living in the heart of a historic neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Air Conditioning",
      "seo_description": "Find luxury apartments in Kansas City's Crossroads with air conditioning and modern amenities at Piper Lofts for an exquisite living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "apartments-with-pool-jackson-county-mo",
      "search_query": "apartments with a pool Jackson County MO",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Jackson County, MO",
      "h2_subtitle": "Explore premium apartments in Jackson County, MO, with access to a wide range of amenities, including a stunning pool for relaxation.",
      "page_copy": "While Piper Lofts in Kansas City's Crossroads district doesn't offer a pool, it provides a luxurious urban lifestyle with other exceptional amenities. Located in the heart of Jackson County, MO, this historic property boasts breathtaking loft apartments characterized by exposed brick, towering ceilings, and sleek modern finishes. Our residences feature stainless steel appliances, granite countertops, and island kitchens, ensuring both style and functionality.\n\nThough we lack a pool, residents can enjoy a magnificent roof terrace with downtown views, and maintenance is always on-site to ensure a seamless living experience. If you're looking for elegance, convenience, and a vibrant community environment, Piper Lofts is your ideal choice in Jackson County. Embrace downtown living with access to all urban attractions within minutes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Jackson County, MO",
      "seo_description": "Explore urban living at Piper Lofts in Jackson County, MO. While offering modern amenities, note that these luxury apartments do not feature a pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "historic-lofts-dishwashers-kansas-city",
      "search_query": "historic lofts with dishwashers Kansas City",
      "category": "Amenity",
      "h1_title": "Historic Lofts with Dishwashers, Kansas City",
      "h2_subtitle": "Find historic lofts with dishwashers in Kansas City's lively Crossroads area, blending old-world charm with modern convenience.",
      "page_copy": "Welcome to Piper Lofts, where historic charm meets contemporary convenience in the heart of Kansas City. Nestled in the Crossroads district, our historic lofts offer a unique living experience with features like exposed brick walls, concrete floors, and lofty ceilings that speak to the area's rich history. Each loft is equipped with modern conveniences, including stainless steel appliances and dishwashers, seamlessly integrating functionality into a stylish living space.\n\nAt Piper Lofts, you'll find not just a home, but a lifestyle. Our residences are designed to cater to your needs, with granite countertops, island kitchens, and in-unit laundry. And while our building's historical essence provides a backdrop of character, amenities such as on-site maintenance and a roof terrace ensure a comfortable, worry-free living experience. Discover the allure of living in a historic loft with modern amenities in Kansas City's vibrant Crossroads neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Historic Lofts with Dishwashers in Kansas City",
      "seo_description": "Discover historic lofts in Kansas City with dishwashers. Experience classic architecture with modern amenities at Piper Lofts in Crossroads.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "downtown-apartments-concierge-service-64108",
      "search_query": "downtown apartments with concierge service 64108",
      "category": "Amenity",
      "h1_title": "Downtown Apartments with Concierge Service",
      "h2_subtitle": "Explore elegant downtown apartments with concierge services in the 64108 ZIP code, offering unmatched luxury and convenience.",
      "page_copy": "While Piper Lofts in the 64108 area of Kansas City doesn't provide concierge services, it offers a unique blend of historic charm and modern amenities in its downtown apartment community. Situated in the vibrant Crossroads district, these studios and lofts capture the essence of loft living with features like exposed brick, soaring ceilings, and concrete floors. \n\nAmenities at Piper Lofts include stainless steel appliances, granite countertops, and island kitchens, ensuring a high standard of living. Residents benefit from prompt maintenance service and can enjoy leisure time on the scenic roof terrace with panoramic city views. While our community may not offer a concierge, Piper Lofts provides an exceptional urban lifestyle that combines history, comfort, and accessibility in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown Apartments with Concierge Service 64108",
      "seo_description": "Discover downtown living in 64108. Piper Lofts offers historic charm and modern amenities, though without concierge services, in Kansas City's Crossroads.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "one-bedroom-lofts-kansas-city",
      "search_query": "one bedroom lofts kansas city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Lofts in Kansas City",
      "h2_subtitle": "Discover elegant one-bedroom lofts in Kansas City, featuring historic charm and modern amenities in the iconic Crossroads area.",
      "page_copy": "Welcome to Piper Lofts, where historic character meets modern living in Kansas City's sought-after Crossroads district. Our one-bedroom lofts provide a unique living experience with their iconic exposed brick, polished concrete floors, and vaulted ceilings that echo the building's storied past. Each loft is consciously designed to offer a seamless blend of style and functionality, featuring stainless steel appliances and kitchen islands, making them perfect for entertaining.\n\nLocated in the vibrant Crossroads neighborhood, Piper Lofts places you in the midst of Kansas City's cultural heartbeat. Enjoy the benefits of urban living with amenities like on-site maintenance and a rooftop terrace that boasts stunning city views. Embrace the opportunity to live in a one-bedroom loft that offers both historic elegance and all the conveniences of modern living, providing an exceptional home base in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Lofts in Kansas City",
      "seo_description": "Explore one-bedroom lofts at Piper Lofts, Kansas City. Experience historic charm and modern amenities in the lively Crossroads neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-crossroads-mo",
      "search_query": "two bedroom apartments crossroads mo",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Crossroads, MO",
      "h2_subtitle": "Explore spacious two-bedroom apartments in the Crossroads, MO, where modern amenities meet historic charm in vibrant Kansas City.",
      "page_copy": "Piper Lofts offers an extraordinary living experience in the heart of the Crossroads district, MO, with its spacious two-bedroom apartments. These unique residences blend the timeless appeal of exposed brick and high ceilings with contemporary features such as stainless steel appliances and granite countertops. Each apartment is thoughtfully designed to enhance both comfort and style, providing a perfect home base for those who appreciate the fusion of past and present.\n\nLiving in Piper Lofts means enjoying a vibrant urban lifestyle with easy access to Kansas City's cultural and entertainment scene. Our community amenities, including a scenic roof terrace and responsive maintenance onsite, complement the historical setting. The two-bedroom layouts give residents ample space, ideal for both living and entertaining, ensuring you experience the best of what Kansas City's Crossroads area has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Crossroads, MO",
      "seo_description": "Discover spacious two-bedroom apartments at Piper Lofts in Crossroads, MO. Enjoy a blend of historic charm and modern amenities in Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-jackson-county",
      "search_query": "three bedroom apartments jackson county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Jackson County",
      "h2_subtitle": "Discover spacious three-bedroom apartments in Jackson County, blending historic loft style with modern conveniences in Kansas City's Crossroads.",
      "page_copy": "Located in the historic H.D. Lee Building, Piper Lofts offers remarkable three-bedroom apartments that cater to those seeking space and style in Jackson County. With their soaring ceilings, expansive layouts, and iconic exposed brick, these apartments provide a unique living experience. Modern finishes such as granite countertops and stainless steel appliances complement the historical elements, making each apartment both practical and elegant.\n\nPiper Lofts is situated in the vibrant Crossroads neighborhood, an area renowned for its cultural vibrancy and artistic flair. Residents enjoy a range of amenities, including a serene roof terrace perfect for relaxing and taking in panoramic downtown views. The maintenance team on-site ensures a hassle-free living experience. Piper Lofts is where the historical charm of Kansas City meets contemporary urban living, ideal for those needing the extra space provided by a three-bedroom layout.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Jackson County",
      "seo_description": "Explore three-bedroom apartments at Piper Lofts in Jackson County. Enjoy loft-style living with modern amenities in the heart of Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "apartments-near-crossroads-charter-schools-kc",
      "search_query": "apartments near Crossroads Charter Schools Kansas City",
      "category": "School",
      "h1_title": "Apartments Near Crossroads Charter Schools",
      "h2_subtitle": "Discover the convenience of living in Kansas City with apartments near Crossroads Charter Schools, offering modern amenities and historical charm.",
      "page_copy": "Piper Lofts provides an ideal living solution for those seeking proximity to Crossroads Charter Schools in Kansas City. Our apartments are located in the historic H.D. Lee Building, where the original architectural details like exposed brick and soaring ceilings merge seamlessly with modern comforts such as stainless steel appliances and granite countertops. Perfectly situated in the Crossroads district, Piper Lofts offers a unique blend of history and contemporary urban living, with a variety of layouts to suit your lifestyle needs.\n\nLiving at Piper Lofts not only places you near Crossroads Charter Schools but also at the heart of Kansas City's cultural scene. Our community features, including a relaxing rooftop terrace and efficient on-site maintenance, make daily living convenient and enjoyable. Embrace the vibrant Crossroads environment, with easy access to educational institutions and city amenities, perfectly suited for families and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Crossroads Charter Schools KC",
      "seo_description": "Find modern loft apartments near Crossroads Charter Schools in Kansas City. Enjoy historic charm with updated amenities in the vibrant Crossroads neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "piper-lofts-close-to-crossroads-academy-quality-hill",
      "search_query": "Piper Lofts close to Crossroads Academy Quality Hill",
      "category": "School",
      "h1_title": "Piper Lofts Near Crossroads Academy Quality Hill",
      "h2_subtitle": "Live near Crossroads Academy Quality Hill at Piper Lofts, where historic charm meets modern convenience in vibrant downtown Kansas City.",
      "page_copy": "Nestled in the vibrant Crossroads district, Piper Lofts offers an exceptional living experience close to Crossroads Academy Quality Hill. Our historic building provides a unique blend of character and modern amenities. Featuring open-concept layouts and stylish finishes like granite countertops and stainless steel appliances, Piper Lofts seamlessly combines the past's charm with contemporary living.\n\nLiving at Piper Lofts means enjoying the dynamic Crossroads neighborhood, known for its cultural attractions and easy access to downtown Kansas City. The building's close proximity to Crossroads Academy Quality Hill makes it an ideal location for those seeking convenient access to quality education. Our community also features a rooftop terrace with stunning views and onsite maintenance services, providing a supportive and enriching environment for our residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Piper Lofts Near Crossroads Academy Quality Hill",
      "seo_description": "Discover historic lofts at Piper Lofts, close to Crossroads Academy Quality Hill. Enjoy modern amenities and vibrant Kansas City living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "jackson-county-rentals-crossroads-preparatory-academy",
      "search_query": "Jackson County rentals by Crossroads Preparatory Academy",
      "category": "School",
      "h1_title": "Jackson County Rentals by Crossroads Prep Academy",
      "h2_subtitle": "Explore available rentals in Jackson County, just steps away from Crossroads Preparatory Academy, offering a perfect blend of style and convenience.",
      "page_copy": "If you're searching for rentals in Jackson County near Crossroads Preparatory Academy, Piper Lofts is a must-see. Located in the historic H.D. Lee Building, our lofts provide the perfect combination of historic charm and modern amenities. With features such as exposed brick, high ceilings, and expansive living spaces, our units offer a unique urban living experience right in the heart of Kansas City's vibrant Crossroads neighborhood.\n\nPiper Lofts isn’t just about location; it’s about a lifestyle. Our residents benefit from modern conveniences like granite countertops and stainless steel appliances, alongside community amenities including a roof terrace and attentive on-site maintenance. With its proximity to Crossroads Preparatory Academy, Piper Lofts provides an ideal setting for those who value convenience and character in their urban home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackson County Rentals by Crossroads Prep Academy",
      "seo_description": "Find rentals in Jackson County near Crossroads Preparatory Academy at Piper Lofts. Enjoy historical charm and modern amenities in the heart of Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "housing-options-near-primitivo-garcia-elementary-kc",
      "search_query": "housing options near Primitivo Garcia Elementary School KC",
      "category": "School",
      "h1_title": "Housing Near Primitivo Garcia Elementary School",
      "h2_subtitle": "Explore diverse housing options near Primitivo Garcia Elementary School in Kansas City, offering a blend of comfort and convenience.",
      "page_copy": "Located in the heart of Kansas City, Piper Lofts offers ideal housing options for indiviuals wanting to be near Primitivo Garcia Elementary School. Situated in the landmark H.D. Lee Building, our lofts are characterized by historic charm with modern-day comforts. Featuring open floor plans, exposed brick, and polished finishes, these units redefine downtown living with their unique style and vibrant atmosphere.\n\nNot only do Piper Lofts provide a convenient location, but they also offer a lifestyle enriched with modern amenities. Residents enjoy stainless steel appliances, granite countertops, and a picturesque rooftop terrace. The proximity to Primitivo Garcia Elementary School makes Piper Lofts an excellent choice for those looking to balance educational accessibility with the energy and conveniences of living in the Crossroads district of Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Primitivo Garcia Elementary School KC",
      "seo_description": "Discover chic loft housing near Primitivo Garcia Elementary School in Kansas City. Enjoy historical charm and modern living at Piper Lofts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "apartments-nearby-guadalupe-centers-high-school-jackson-county",
      "search_query": "apartments nearby Guadalupe Centers High School Jackson County",
      "category": "School",
      "h1_title": "Apartments Near Guadalupe Centers High School",
      "h2_subtitle": "Find your perfect apartment near Guadalupe Centers High School, nestled in the vibrant heart of Jackson County, Kansas City.",
      "page_copy": "For those seeking apartments near Guadalupe Centers High School in Jackson County, Piper Lofts offers an unparalleled urban living experience. Situated in the historic H.D. Lee Building, our lofts feature open layouts with modern touches like granite countertops and stainless steel appliances, creating a stylish and comfortable home environment. The exposed brick and high ceilings add a distinct charm that reflects the vibrant Crossroads neighborhood.\n\nPiper Lofts is ideally positioned for easy living with a perfect blend of downtown accessibility and educational convenience. Residents benefit from on-site amenities such as a rooftop terrace with stunning city views and dedicated maintenance support. Piper Lofts provides a welcoming community close to Guadalupe Centers High School, enhancing both lifestyle and daily commutes within Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Guadalupe Centers High School",
      "seo_description": "Explore stylish apartments near Guadalupe Centers High School in Jackson County at Piper Lofts. Enjoy modern amenities and a convenient Kansas City location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "crossroads-area-lofts-near-guadalupe-centers-middle-school",
      "search_query": "Crossroads area lofts close to Guadalupe Centers Middle School",
      "category": "School",
      "h1_title": "Lofts Near Guadalupe Centers Middle School",
      "h2_subtitle": "Discover lofts in the Crossroads area, just minutes from Guadalupe Centers Middle School, offering a unique blend of history and modernity.",
      "page_copy": "Piper Lofts, located in Kansas City's dynamic Crossroads neighborhood, offers loft living close to Guadalupe Centers Middle School. Encompassing the landmark H.D. Lee Building, our lofts capture historic elegance with exposed brick, towering ceilings, and expansive windows that bring in natural light. These spaces are designed for comfort and style, appealing to those looking for a refined yet urban lifestyle.\n\nWith top-tier amenities such as granite countertops and stainless steel appliances, Piper Lofts is more than just a home; it’s a community. Enjoy views from the rooftop terrace and the convenience of on-site maintenance, ensuring you focus on what matters most. Piper Lofts provides a prime location for families and professionals seeking proximity to Guadalupe Centers Middle School while enjoying the richness and culture of the Crossroads.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lofts Near Guadalupe Centers Middle School",
      "seo_description": "Live in historic lofts near Guadalupe Centers Middle School at Piper Lofts, where modern amenities meet classic charm in Kansas City's Crossroads area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "units-available-near-lincoln-college-preparatory-academy-kc",
      "search_query": "units available near Lincoln College Preparatory Academy Kansas City",
      "category": "School",
      "h1_title": "Units Near Lincoln College Preparatory Academy",
      "h2_subtitle": "Explore available units in Kansas City near Lincoln College Preparatory Academy, designed to provide comfort and convenience.",
      "page_copy": "Looking for units near Lincoln College Preparatory Academy in Kansas City? Piper Lofts provides an ideal residential choice with its vibrant yet cozy settings nestled in the iconic H.D. Lee Building. Our units are thoughtfully designed with one-, two-, and three-bedroom options, offering the perfect blend of historic charm and modern functionality with features like exposed brick and polished concrete floors.\n\nResidents enjoy premium amenities such as stainless steel appliances, granite countertops, and a communal rooftop terrace with amazing city views. Maintenance is available on-site, ensuring our community remains comfortable and welcoming. Located in the bustling Crossroads district, Piper Lofts offers easy access to educational facilities, making it a top choice for individuals seeking proximity to Lincoln College Preparatory Academy while enjoying all that Kansas City has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Units Near Lincoln College Preparatory Academy",
      "seo_description": "Discover available units near Lincoln College Preparatory Academy at Piper Lofts in Kansas City. Enjoy a vibrant historic setting with modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "rentals-close-to-university-of-missouri-kansas-city",
      "search_query": "rentals close to University of Missouri-Kansas City",
      "category": "School",
      "h1_title": "Rentals Near University of Missouri-Kansas City",
      "h2_subtitle": "Find rentals conveniently located near the University of Missouri-Kansas City, offering the best in city living.",
      "page_copy": "Piper Lofts provides exceptional rentals close to the University of Missouri-Kansas City, perfect individuals seeking convenience and comfort. Housed in the historic H.D. Lee Building, our lofts feature spacious open layouts with contemporary finishes like granite countertops and stainless steel appliances, making them ideal for modern living.\n\nSituated in the heart of Kansas City's vibrant Crossroads neighborhood, Piper Lofts offers unparalleled access to downtown amenities and services. Residents can unwind on the rooftop terrace or benefit from on-site maintenance, ensuring a hassle-free living experience. Whether you're attending classes or working on campus, our rentals offer an ideal location with easy access to the University's bustling campus environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near University of Missouri-Kansas City",
      "seo_description": "Discover Piper Lofts rentals near the University of Missouri-Kansas City. Enjoy spacious, modern living with easy access to campus and city life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "apartments-adjacent-to-kansas-city-art-institute",
      "search_query": "Kansas City Art Institute adjacent apartments",
      "category": "School",
      "h1_title": "Apartments Near Kansas City Art Institute",
      "h2_subtitle": "Explore modern apartments adjacent to the Kansas City Art Institute, perfect for students and professionals in the creative field.",
      "page_copy": "Located in the artistic hub of Kansas City's Crossroads, Piper Lofts offers apartments adjacent to the Kansas City Art Institute. Situated in the storied H.D. Lee Building, our lofts brilliantly combine historic architecture with contemporary design elements such as granite countertops, and stainless steel appliances.\n\nResidents of Piper Lofts benefit from a creative community vibe, on-site maintenance, and a stunning rooftop terrace that offers panoramic city views. Whether you're a student, faculty member, or art enthusiast, our apartments provide a seamless blend of convenience and modern style, all within easy reach of the Kansas City Art Institute. Embrace a lifestyle that nurtures creativity and innovation at Piper Lofts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City Art Institute",
      "seo_description": "Discover stylish apartments near the Kansas City Art Institute at Piper Lofts. Experience modern living in the city's vibrant Crossroads district.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "jackson-county-lofts-near-kansas-city-university",
      "search_query": "Jackson County lofts near Kansas City University",
      "category": "School",
      "h1_title": "Jackson County Lofts Near Kansas City University",
      "h2_subtitle": "Discover lofts in Jackson County near Kansas City University, offering a unique blend of historic charm and modern amenities.",
      "page_copy": "Looking for Jackson County lofts near Kansas City University? Piper Lofts, situated in the historic H.D. Lee Building, is the perfect place to call home. Our unique lofts provide spacious one-, two-, and three-bedroom floor plans, complete with soaring ceilings, exposed brick, and sleek finishes like granite countertops and stainless steel appliances.\n\nLocated in Kansas City's vibrant Crossroads district, Piper Lofts offers easy access to campus life and downtown attractions. Those seeking a home at Piper Lofts will appreciate the on-site maintenance and the communal rooftop terrace with stunning city views. Experience the perfect mix of historic character and modern comfort just minutes from Kansas City University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackson County Lofts Near Kansas City University",
      "seo_description": "Explore Piper Lofts in Jackson County, ideally located near Kansas City University, offering spacious, modern living spaces in the vibrant Crossroads area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "lofts-close-to-childrens-mercy-adele-hall-crossroads",
      "search_query": "lofts close to Children's Mercy Adele Hall Crossroads",
      "category": "Hospital",
      "h1_title": "Lofts Close to Children's Mercy Adele Hall",
      "h2_subtitle": "Discover lofts close to Children's Mercy Adele Hall in Crossroads, offering a perfect blend of convenience and modern living.",
      "page_copy": "Piper Lofts provides exceptional loft living close to Children's Mercy Adele Hall in the lively Crossroads neighborhood of Kansas City. These lofts are housed in the iconic H.D. Lee Building, featuring open layouts with exposed brick, polished concrete floors, and modern amenities like stainless steel appliances and granite countertops.\n\nPiper Lofts offers a unique community atmosphere enhanced by features such as a communal rooftop terrace and on-site maintenance. With its combination of historic charm and proximity to Children's Mercy Adele Hall, Piper Lofts is the perfect choice for those seeking comfort and convenience in the heart of Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lofts Near Children's Mercy Adele Hall",
      "seo_description": "Explore stylish Piper Lofts near Children's Mercy Adele Hall in Crossroads, Kansas City, offering modern amenities and historic character in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "lofts-near-henry-wollman-bloch-fountain-kansas-city",
      "search_query": "lofts near henry wollman bloch fountain kansas city",
      "category": "Park",
      "h1_title": "Lofts Near Henry Wollman Bloch Fountain",
      "h2_subtitle": "Explore lofts near Henry Wollman Bloch Fountain in Kansas City, where historic charm meets urban sophistication.",
      "page_copy": "Nestled conveniently close to the iconic Henry Wollman Bloch Fountain, Piper Lofts offer fantastic living options in Kansas City’s vibrant Crossroads district. Our lofts sit within the time-honored H.D. Lee Building, offering residents unique features such as exposed brick, expansive windows, and modern upgrades like granite countertops and island kitchens.\n\nPerfectly positioned for those who love urban life, Piper Lofts provides easy access to the dynamic art scene and numerous dining options. Enjoy scenic downtown views from our rooftop terrace and rely on our maintenance team for any needs. Embrace a lifestyle combining historic elegance and urban energy at Piper Lofts near the Henry Wollman Bloch Fountain.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lofts Near Henry Wollman Bloch Fountain",
      "seo_description": "Find modern lofts at Piper Lofts, located near Henry Wollman Bloch Fountain in Kansas City, offering a blend of historic charm and urban sophistication.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "crossroads-apartments-by-city-market-park-kcmo",
      "search_query": "crossroads apartments by city market park kcmo",
      "category": "Park",
      "h1_title": "Crossroads Apartments by City Market Park KCMO",
      "h2_subtitle": "Discover Crossroads apartments by City Market Park in KCMO, where modern living meets cultural vibrancy.",
      "page_copy": "Piper Lofts provides a prime location for those searching for Crossroads apartments by City Market Park in KCMO. Situated in the historic H.D. Lee Building, our apartments offer one-, two-, and three-bedroom layouts, featuring unique architectural details such as exposed brick and high ceilings, paired with modern conveniences like stainless steel appliances and granite countertops.\n\nLiving at Piper Lofts means enjoying the dynamic Crossroads district of Kansas City, with easy access to the energetic City Market Park. The community boasts a rooftop terrace for relaxation and an exceptional maintenance team on-site, making it the perfect blend of city buzz and comfort. Experience the vibrant lifestyle that Crossroads living has to offer at Piper Lofts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Crossroads Apartments by City Market Park",
      "seo_description": "Discover stylish Piper Lofts in the Crossroads near City Market Park KCMO, offering modern amenities and a vibrant downtown lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "kcmo-properties-close-to-river-market-off-leash-dog-park",
      "search_query": "kcmo properties close to river market off-leash dog park",
      "category": "Park",
      "h1_title": "KCMO Properties Close to River Market Dog Park",
      "h2_subtitle": "Explore KCMO properties close to River Market Off-Leash Dog Park, ideal for pet lovers seeking urban convenience.",
      "page_copy": "Piper Lofts, located in the Crossroads district of Kansas City, presents an exceptional living choice for those wanting KCMO properties close to River Market Off-Leash Dog Park. Our loft apartments are situated in the historic H.D. Lee Building and feature unique architectural elements, including exposed brick and soaring ceilings, beside modern touches such as stainless steel appliances and granite countertops.\n\nOur pet-friendly lofts reside in a vibrant neighborhood offering easy access to green spaces like the River Market Off-Leash Dog Park. With an on-site maintenance team and a communal rooftop terrace, Piper Lofts ensures both comfort and luxury. Enjoy a perfect blend of urban living and outdoor adventure right from our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KCMO Properties Near River Market Dog Park",
      "seo_description": "Find pet-friendly Piper Lofts in KCMO, close to River Market Off-Leash Dog Park, offering modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "downtown-living-near-berkley-riverfront-mo",
      "search_query": "downtown living near berkley riverfront mo",
      "category": "Park",
      "h1_title": "Downtown Living Near Berkley Riverfront MO",
      "h2_subtitle": "Experience exceptional downtown living near Berkley Riverfront MO with Piper Lofts' unique character and modern amenities.",
      "page_copy": "Discover the perfect blend of historic charm and modern luxury with downtown living near Berkley Riverfront MO at Piper Lofts. Located in Kansas City's lively Crossroads neighborhood, our lofts feature distinctive elements such as exposed brick and soaring ceilings, complemented by polished features like granite countertops and an island kitchen.\n\nPiper Lofts stands ready for those who thrive in dynamic urban environments, offering easy access to Berkley Riverfront MO's scenic outdoor spaces. Our residents enjoy views from a rooftop terrace and the convenience of on-site maintenance. Embrace urban sophistication and outdoor access in one of Kansas City's most vibrant districts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown Living Near Berkley Riverfront",
      "seo_description": "Live at Piper Lofts in downtown KCMO, just moments from Berkley Riverfront, combining modern luxury and rich history.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167655",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Piper Lofts offers stylish apartments near Kansas City International Airport, perfect for city living with convenient airport access.",
      "page_copy": "Piper Lofts is the ideal choice for those seeking apartments near Kansas City International Airport. Situated in the bustling Crossroads area of Kansas City, our lofts combine historic architectural details with modern amenities, such as stainless steel appliances and granite countertops. These open, spacious layouts include one-, two-, and three-bedroom options, perfect for the modern urbanite.\n\nLocated in the landmark H.D. Lee Building, Piper Lofts provides easy access to both downtown Kansas City and the airport, making travel straightforward. Added features like our rooftop terrace and reliable on-site maintenance staff ensure a comfortable, convenient living environment. Experience the best of city and travel convenience at Piper Lofts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building in a city skyline at dusk.",
        "public_id": "019ff7b8-cb54-70eb-b11b-44cade11ca4a",
        "storage_key": "property/6767906449167655/019ff7b8-cb54-70eb-b11b-44cade11ca4a.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stylish Apartments by KC International Airport",
      "seo_description": "Discover Piper Lofts for modern living near Kansas City International Airport, offering historic charm and easy access to major travel hubs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701855693"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M87FPSH6"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/645456ac-2fb0-4ea3-8391-669e293ffed5/app.js?property=645456ac-2fb0-4ea3-8391-669e293ffed5&amp;propertyName=Piper Lofts at Crossroads Apartments&amp;channelUuid=ed72c165-8c33-11ef-b558-42010aa8d42b\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "39355900278"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8xvr302lvjk"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "816-852-3439"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imp4dzlKc0toWmdMK0lEaWhvK0RsOFE9PSIsInZhbHVlIjoiaURiNXFCTU5qdUwxQUpUYkNScXltdz09IiwibWFjIjoiOGM3MWU2Y2E3NDNkZjkwZjYyYzMxN2U2MTRmN2I5MTAyOTBkY2EzYWI0NGNmMGQ3MzYwNjA0ZGYzYWU1NWFmNCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701855693",
  "custom_google_gtm_id": "GTM-M87FPSH6",
  "custom_rollout_phase": "Batch 1",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/645456ac-2fb0-4ea3-8391-669e293ffed5/app.js?property=645456ac-2fb0-4ea3-8391-669e293ffed5&amp;propertyName=Piper Lofts at Crossroads Apartments&amp;channelUuid=ed72c165-8c33-11ef-b558-42010aa8d42b\"></script>",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "39355900278",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8xvr302lvjk",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "816-852-3439",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imp4dzlKc0toWmdMK0lEaWhvK0RsOFE9PSIsInZhbHVlIjoiaURiNXFCTU5qdUwxQUpUYkNScXltdz09IiwibWFjIjoiOGM3MWU2Y2E3NDNkZjkwZjYyYzMxN2U2MTRmN2I5MTAyOTBkY2EzYWI0NGNmMGQ3MzYwNjA0ZGYzYWU1NWFmNCJ9",
  "custom_audioeye_site_id": "4a3c406f-4ef8-4a13-9d27-83bcbb04e2db",
  "custom_audioeye_site_hash": "86ce4313aecdca059f387e5c3fbfb706"
};

export const generatedAt = '2026-11-03T23:00:58.740Z';
